import React from "react";
import "./Index.css";
import { Container, Row, Col } from 'react-grid-system';
import { isMobile } from "react-device-detect";
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Input,
  Grid,
  FormHelperText,
  Button,
  FormLabel
} from "@material-ui/core";
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'

import TextField from "@material-ui/core/TextField";
import { Hidden } from '@material-ui/core';
import DialogActions from "@material-ui/core/DialogActions";
import { GREY, RED, LIGHTBLUE, LIGHTGREY, MAROONHOVER } from "../../utils/color_utils";
import SendIcon from "@material-ui/icons/Send";
import { showToast } from "../../store/actions/toastAction";
import { createSurvey } from "../../store/actions/SurveyActions";
import { addMorePoints } from '../../store/actions/freshCardActions'
import { updateSurvey } from "../../store/actions/surveyUpdate";
import { testHistoryActions } from "../../store/actions/testHistoryActions";
import { saveTestAttempt, getTestAttempt, updateTestAttempt } from "../../store/actions/testAttemptActions";
import { confirmAlert } from 'react-confirm-alert';
import { getCreationBonus, validateMinimumQuestions, getDifficultyInfo } from "../../utils/test_utils";
// import { surveyStats } from "../../store/actions/surveyStatsAction";
// import { simpleAction } from "../../store/actions/simpleAction";
// import { surveyTestsDisplay } from "../../store/actions/surveyTestsDisplayAction";
//import firebase from "../../store/firebase";
import { connect } from "react-redux";
import { withRouter, Prompt } from "react-router-dom";
import TestValidator from "../../components/Dialogs/TestValidator";
import {
  SURVEY_LIST,
  UPDATE_SURVEY,
  SURVEY_STATS_LIST,
  SIMPLE_VALUES,
  SURVEY_TESTS_LIST,
  SHOW_TOAST,
  TEST_HISTORY
} from "../../store/actions/types";
import { array } from "prop-types";
import survey from './img/surveypic.jpg';
import './sidebar.css'; 
  import Tooltip from '@material-ui/core/Tooltip';
  //import ReactRadioGroup from 'react-simple-radio-button';
  import axios from 'axios';
  import { FB_URL } from '../../store/actions/types';
  import { generateAITest, regenerateSingleQuestion } from '../../utils/ai_test_generator';
  import { checkTranscriptDuplicate, saveTranscriptExcerpt } from '../../utils/transcript_excerpts';

const sendBtn = {
  backgroundColor: LIGHTBLUE,
  color: "#fff"
};
const sendBtn2 = {
  backgroundColor: RED,
  color: "#fff",
  cursor:'pointer'
};
const table = {
    color: "#515A5A",
    fontSize: 14,
    border: "1px solid #CAC9C8",
    backgroundColor: '#F2F3F4',
    padding: 1,
    borderRadius: 7
}
const tableh = {
  color: "#515A5A",
  fontSize: 14,
  border: "1px solid #707B7C",
  backgroundColor: '#F2F3F4',
  padding: 10,
  borderRadius: 15
}
const tableM = {
  color: "#515A5A",
  fontSize: 18,
  border: "1px solid #707B7C",
  backgroundColor: '#F2F3F4',
  padding: 1,
  borderRadius: 15
}

const buttonStyle = {
    backgroundColor: RED,
    color: "#fff",
    width: "120px",
    height: "48px",
    border: "10px solid",
    borderColor: "#fff",
    borderRadius: "15px",
    textDecoration: "none"
  };
  
  const hoverbuttonStyle = {
    backgroundColor: MAROONHOVER,
    color: "#fff",
    width: "120px",
    height: "48px",
    border: "10px solid",
    borderColor: "#fff",
    borderRadius: "15px",
    textDecoration: "none"
  };

const styles = {
  mlist: {
    width: 250,
  },
  survs: {
    width: 1500,
  },
  row2: {
  },
  col1: {
    backgroundColor: 'yellow',
  },
  col2: {
    backgroundColor: 'brown',
  },
  col: {
    padding: '1rem',
    backgroundColor: '#33b5e5',
    border: '2px solid #fff',
    color: '#fff',
    textAlign: 'center'
    }
};
function handleChange() {
    // Handle select function
  }
  function swapStuff(str) {
    var c, cc;
      c = str.replace(/\./g, (i => _ => ' ?'[i = 1 - i])(1));
      cc = c.replace(/\,/g, (i => _ => ' ?'[i = 1 - i])(1));
      cc = cc.replace(/\'/g, (i => _ => '?'[i = 1 - i])(1));
      cc = cc.replace(/\?/g, (i => _ => ' ?'[i = 1 - i])(1));
      
     // cc = cc.replace(/.$/," ");
  
    return cc;
   }
  
  class CreateaSurvey extends React.Component {
      constructor (props) {   
        super(props);
       // this.props.letgoPic(false);
       this.submitPost = this.submitPost.bind(this);
      }

   preventCopy = (e) => {
   e.preventDefault();
   };

      state = {
        stitle: this.props.title,
        companyid: this.props.userdata.companyID,
        Qnumber: 0,
        sQuestion: '',
        sAnswer1: '',
        sAnswer2: '',
        sAnswer3: '',
        sAnswer4: '',
        sAnswer5: '',
       // sAnswer6: '',
        QandA1: [],
        QandA2: [],
        QandA3: [],
        QandA4: [],
        QandA5: [],
        QandA6: [],
        QandA7: [],
        QandA8: [],
        QandA9: [],
        QandA10: [],
        QandA11: [],
        QandA12: [],
        // Enhanced test features
        sections: [{ id: 1, name: 'Section 1', questions: [] }],
        currentSection: 0,
        maxQuestionsPerSection: 15,
        estimatedLCReward: 0.07,
        typeofsurvey: "T",
        defaultsurvey: "Select Survey type",
        focus: true,
        submitLev: 1,
        ownMaterial: true,
        startPublish: false,
        // Question editing functionality
        editingQuestionIndex: -1,  // -1 means not editing, >= 0 means editing that question index
        showQuestionsList: false,   // Toggle to show/hide questions list
        // AI Validation
        showTestValidator: false,
        testValidationData: null,
        leadContext: null,
        // Thought/Lead data
        thoughtData: null,
        fetchingThought: false,
            // AI Test Generation
    useAIGeneration: true,
    aiTestConfig: {
      numberOfSections: 2,
      questionsPerSection: 5,
      difficulty: 'basic', // basic (default), medium, hard - max 3 sections, 5 questions each
      focusAreas: [] // Will be populated based on lead category
    },
    generatingTest: false,
    showAIConfig: true,
    // Difficulty persistence
    difficultyLocked: false,
    existingTestAttempt: null,
        // AI Test Preview & Regeneration
        showAIPreview: false,
        aiGeneratedTest: null,
        previewMode: false,
        // Transcript functionality for multimedia content
        transcript: '',
        hasAttachments: false,
        // Transcript validation state
        transcriptValidated: false,
        transcriptValidating: false,
        transcriptValidationMessage: '',
        transcriptSimilarityScore: null,
        transcriptLocked: false
        ,
        // Per-question regeneration loading flag: `${sectionIndex}-${qIndex}` or null
        regeneratingQuestion: null
      ,
        // Navigation lock
        exitAllowed: false,
        lockActive: true
      }

    // NEW: Add section functionality
    addSection = () => {
      const newSectionId = this.state.sections.length + 1;
      const newSection = {
        id: newSectionId,
        name: `Section ${newSectionId}`,
        questions: []
      };
      
      this.setState({
        sections: [...this.state.sections, newSection]
      });
    };

    // NEW: Remove section
    removeSection = (sectionId) => {
      if (this.state.sections.length <= 1) {
        alert('⚠️ You must have at least one section in your test.');
        return;
      }
      
      // Find the index of the section being removed
      const sectionIndex = this.state.sections.findIndex(section => section.id === sectionId);
      const updatedSections = this.state.sections.filter(section => section.id !== sectionId);
      
      // Calculate new currentSection index
      let newCurrentSection = this.state.currentSection;
      if (sectionIndex < this.state.currentSection) {
        // Section removed before current section, decrease current index
        newCurrentSection = this.state.currentSection - 1;
      } else if (sectionIndex === this.state.currentSection) {
        // Current section is being removed, switch to previous section or first section
        newCurrentSection = Math.max(0, this.state.currentSection - 1);
      }
      // If section removed after current section, keep currentSection the same
      
      // Ensure currentSection is within bounds
      newCurrentSection = Math.min(newCurrentSection, updatedSections.length - 1);
      
      this.setState({
        sections: updatedSections,
        currentSection: newCurrentSection
      });
    };

    // NEW: Update section name
    updateSectionName = (sectionId, newName) => {
      const updatedSections = this.state.sections.map(section => 
        section.id === sectionId ? { ...section, name: newName } : section
      );
      
      this.setState({
        sections: updatedSections
      });
    };

    

    // Reset function for when dialog closes
    resetTest = () => {
      this.setState({
        Qnumber: 0,
        sQuestion: '',
        sAnswer1: '',
        sAnswer2: '',
        sAnswer3: '',
        sAnswer4: '',
        sAnswer5: '',
        currentSection: 0,
        sections: [{ id: 1, name: 'Section 1', questions: [] }],
        estimatedLCReward: 0.07,
        startPublish: false
      });
    };

    // Clear form fields when switching sections
    clearQuestionForm = () => {
      this.setState({
        sQuestion: '',
        sAnswer1: '',
        sAnswer2: '',
        sAnswer3: '',
        sAnswer4: '',
        sAnswer5: '',
        editingQuestionIndex: -1
      });
    };

    // Decode category ID to category name using competencies list
    decodeCategoryId = (categoryId) => {
      try {
        // Check if competenciesList exists and has the ID
        if (this.props.competenciesList && this.props.competenciesList.competencies) {
          const competency = this.props.competenciesList.competencies.find(comp => 
            comp.id == categoryId || comp.competencyID == categoryId
          );
          
          if (competency) {
            return competency.name || competency.competencyName || competency.title;
          }
        }
        
        // Fallback: Try to map common IDs to known categories
        // Based on console output and lead creation dialogs
        const categoryMap = {
          '1': 'Motivation',
          '2': 'Authenticity', 
          '3': 'Purpose',
          '4': 'Direction',
          '5': 'Values Leadership',
          '6': 'Organisational Leadership',
          '7': 'Performance Leadership',
          '8': 'Innovation Leadership'
        };
        
        if (categoryMap[categoryId]) {
          return categoryMap[categoryId];
        }
        
        return null;
        
      } catch (error) {
        return null;
      }
    };

    // Extract thought data from existing props
    fetchThoughtData = () => {
      if (!this.props.thoughtID || this.state.fetchingThought) {
        return;
      }

      // If we already have thought data for the current thoughtID, skip
      if (this.state.thoughtData) {
        const td = this.state.thoughtData;
        const currentId = this.props.thoughtID;
        if (
          td.thoughtID === currentId ||
          td.id === currentId ||
          td.key === currentId ||
          td.dailyThoughtID === currentId
        ) {
          return;
        }
      }

      this.setState({ fetchingThought: true });

      try {
        // Check if we already have thought data in props
        if (this.props.thoughtsData && Array.isArray(this.props.thoughtsData)) {
          const thoughtData = this.props.thoughtsData.find(thought => {
            return thought.thoughtID === this.props.thoughtID || 
                   thought.id === this.props.thoughtID ||
                   thought.key === this.props.thoughtID ||
                   thought.dailyThoughtID === this.props.thoughtID;
          });
          
          if (thoughtData) {
            this.setState({ 
              thoughtData: thoughtData,
              fetchingThought: false 
            }, () => {
              this.updateAttachmentStatus();
            });
            return;
          }
        }

        // Check thoughts.ilead array for the specific thought
        if (this.props.thoughts && this.props.thoughts.ilead && Array.isArray(this.props.thoughts.ilead)) {
          const thoughtData = this.props.thoughts.ilead.find(thought => 
            thought.thoughtID === this.props.thoughtID || 
            thought.id === this.props.thoughtID ||
            thought.key === this.props.thoughtID ||
            thought.dailyThoughtID === this.props.thoughtID
          );
          
          if (thoughtData) {
            this.setState({ 
              thoughtData: thoughtData,
              fetchingThought: false 
            }, () => {
              this.updateAttachmentStatus();
            });
            return;
          }
        }

        // Also check thoughts.organisational array
        if (this.props.thoughts && this.props.thoughts.organisational && Array.isArray(this.props.thoughts.organisational)) {
          const thoughtData = this.props.thoughts.organisational.find(thought => 
            thought.thoughtID === this.props.thoughtID || 
            thought.id === this.props.thoughtID ||
            thought.key === this.props.thoughtID ||
            thought.dailyThoughtID === this.props.thoughtID
          );
          
          if (thoughtData) {
            this.setState({ 
              thoughtData: thoughtData,
              fetchingThought: false 
            }, () => {
              this.updateAttachmentStatus();
            });
            return;
          }
        }

        // Check group forums and other collections for the specific thought
        const additionalCollections = [
          this.props.thoughts && this.props.thoughts.groupposts,
          this.props.thoughts && this.props.thoughts.gcthoughts,
          this.props.thoughts && this.props.thoughts.dailythoughts
        ];

        for (const collection of additionalCollections) {
          if (collection && Array.isArray(collection)) {
            const thoughtData = collection.find(thought =>
              thought.thoughtID === this.props.thoughtID ||
              thought.id === this.props.thoughtID ||
              thought.key === this.props.thoughtID ||
              thought.dailyThoughtID === this.props.thoughtID
            );
            if (thoughtData) {
              this.setState({
                thoughtData: thoughtData,
                fetchingThought: false
              }, () => {
                this.updateAttachmentStatus();
              });
              return;
            }
          }
        }

        this.setState({ fetchingThought: false });

      } catch (error) {
        this.setState({ fetchingThought: false });
      }
    };

    // Extract lead context from props for AI validation
    extractLeadContext = () => {
      try {
        // Try to extract lead context from various sources
        let leadTitle = '';
        let leadCategory = 'Not specified';
        
        // PRIORITY 1: Use fetched thought data if available
        if (this.state.thoughtData) {
          leadTitle = this.state.thoughtData.title || this.state.thoughtData.dailyThoughtDescription || '';
          
          if (this.state.thoughtData.competency) {
            leadCategory = this.state.thoughtData.competency;
          } else if (this.state.thoughtData.category) {
            leadCategory = this.state.thoughtData.category;
          }
        } else {
          // PRIORITY 2: Try to find thought data in props.thoughts
          if (this.props.thoughts && this.props.thoughtID && this.props.thoughts[this.props.thoughtID]) {
            const thoughtData = this.props.thoughts[this.props.thoughtID];
            leadTitle = thoughtData.title || thoughtData.dailyThoughtDescription || '';
            
            if (thoughtData.competency) {
              leadCategory = thoughtData.competency;
            } else if (thoughtData.category) {
              leadCategory = thoughtData.category;
            }
          } else {
            // PRIORITY 3: Fallback to props-based extraction
            // Check for title in different prop locations
            if (this.props.title) {
              leadTitle = this.props.title;
            } else if (this.props.data && this.props.data.title) {
              leadTitle = this.props.data.title;
            } else if (this.props.itemData && this.props.itemData.title) {
              leadTitle = this.props.itemData.title;
            } else if (this.props.leadData && this.props.leadData.title) {
              leadTitle = this.props.leadData.title;
            } else if (this.props.thoughtData && this.props.thoughtData.title) {
              leadTitle = this.props.thoughtData.title;
            }
          }
        }
        
        // Enhanced category extraction - check multiple possible locations
        const possibleCategoryKeys = [
          'competency', 'category', 'competencyName', 'leadCategory', 'thoughtCategory',
          'valueDesc', 'competencyname', 'leadType', 'topicCategory',
          'type', 'competencytype', 'categoryType'
        ];
        
        // Check direct props
        for (const key of possibleCategoryKeys) {
          if (this.props[key] && this.props[key] !== 'undefined' && this.props[key].trim() !== '') {
            leadCategory = this.props[key];
            
            // If it's a numeric ID, try to decode it to category name
            if (/^\d+$/.test(leadCategory) && this.props.competenciesList) {
              const decodedCategory = this.decodeCategoryId(leadCategory);
              if (decodedCategory) {
                leadCategory = decodedCategory;
              }
            }
            break;
          }
        }
        
        // Check nested data objects if no direct category found
        if (leadCategory === 'Not specified') {
          const dataObjects = ['data', 'itemData', 'leadData', 'thoughtData', 'props'];
          
          for (const dataObj of dataObjects) {
            if (this.props[dataObj] && typeof this.props[dataObj] === 'object') {
              for (const key of possibleCategoryKeys) {
                if (this.props[dataObj][key] && this.props[dataObj][key] !== 'undefined' && this.props[dataObj][key].trim() !== '') {
                  leadCategory = this.props[dataObj][key];
                  break;
                }
              }
              if (leadCategory !== 'Not specified') break;
            }
          }
        }
        
        // Check if props.props exists (nested props pattern)
        if (leadCategory === 'Not specified' && this.props.props && typeof this.props.props === 'object') {
          for (const key of possibleCategoryKeys) {
            if (this.props.props[key] && this.props.props[key] !== 'undefined' && this.props.props[key].trim() !== '') {
              leadCategory = this.props.props[key];
              
              // If it's a numeric ID, try to decode it to category name
              if (/^\d+$/.test(leadCategory)) {
                const decodedCategory = this.decodeCategoryId(leadCategory);
                if (decodedCategory) {
                  leadCategory = decodedCategory;
                }
              }
              break;
            }
          }
        }
        
        return {
          title: leadTitle || 'Test Quiz',
          category: leadCategory,
          transcript: this.state.transcript || ''
        };
      } catch (error) {
        return {
          title: 'Test Quiz',
          category: 'Not specified',
          transcript: this.state.transcript || ''
        };
      }
    };

    // Check if the thought data has ANY attachments that might need transcripts
    checkForAttachments = () => {
      const { thoughtData } = this.state;
      if (!thoughtData) return false;
      
      // Check for video attachments (uploaded videos)
      const hasVideos = thoughtData.videos && 
                       typeof thoughtData.videos === 'object' && 
                       Object.keys(thoughtData.videos).length > 0;
      
      // Check for podcast attachments (uploaded podcasts)
      const hasPodcasts = thoughtData.podcasts && 
                         typeof thoughtData.podcasts === 'object' && 
                         Object.keys(thoughtData.podcasts).length > 0;
      
      // Check for external video links (from videosObj array)
      const hasVideoObjects = thoughtData.videosObj && 
                             Array.isArray(thoughtData.videosObj) && 
                             thoughtData.videosObj.length > 0;
      
      // Check for external podcast links (from podcastsObj array)
      const hasPodcastObjects = thoughtData.podcastsObj && 
                               Array.isArray(thoughtData.podcastsObj) && 
                               thoughtData.podcastsObj.length > 0;
      
      // Check for uploaded video files (videourl property)
      const hasVideoUrl = thoughtData.videourl && 
                         typeof thoughtData.videourl === 'object' && 
                         Object.keys(thoughtData.videourl).length > 0;
      
      // Check for uploaded podcast files (podcasturl property)
      const hasPodcastUrl = thoughtData.podcasturl && 
                           typeof thoughtData.podcasturl === 'object' && 
                           Object.keys(thoughtData.podcasturl).length > 0;
      
      // Check for external article links (urls property)
      const hasUrls = thoughtData.urls && 
                     typeof thoughtData.urls === 'object' && 
                     Object.keys(thoughtData.urls).length > 0;
      
      // Check for external article links (from articlesObj array)
      const hasArticleObjects = thoughtData.articlesObj && 
                               Array.isArray(thoughtData.articlesObj) && 
                               thoughtData.articlesObj.length > 0;
      
      // Check for uploaded images (imageurl property)
      const hasImageUrl = thoughtData.imageurl && 
                         typeof thoughtData.imageurl === 'object' && 
                         Object.keys(thoughtData.imageurl).length > 0;
      
      // Check for uploaded files (fileurl property)
      const hasFileUrl = thoughtData.fileurl && 
                        typeof thoughtData.fileurl === 'object' && 
                        Object.keys(thoughtData.fileurl).length > 0;
      
      // Check for uploaded files (files property)
      const hasFiles = thoughtData.files && 
                      typeof thoughtData.files === 'object' && 
                      Object.keys(thoughtData.files).length > 0;
      
      // Check for external file links (from filesObj array)
      const hasFileObjects = thoughtData.filesObj && 
                            Array.isArray(thoughtData.filesObj) && 
                            thoughtData.filesObj.length > 0;
      
      return hasVideos || hasPodcasts || hasVideoObjects || hasPodcastObjects || 
             hasVideoUrl || hasPodcastUrl || hasUrls || hasArticleObjects || 
             hasImageUrl || hasFileUrl || hasFiles || hasFileObjects;
    };

    // Update attachment detection when thought data changes
    updateAttachmentStatus = () => {
      const hasAttachments = this.checkForAttachments();
      if (this.state.hasAttachments !== hasAttachments) {
        this.setState({ hasAttachments });
      }
    };

    // Handle transcript text change
    handleTranscriptChange = (e) => {
      this.setState({ 
        transcript: e.target.value,
        // Reset validation state when transcript changes
        transcriptValidated: false,
        transcriptValidationMessage: '',
        transcriptSimilarityScore: null,
        transcriptLocked: false
      });
    };

    // Validate transcript for duplicates (new process)
    validateTranscript = async () => {
      if (!this.state.hasAttachments) return true;
      const transcriptText = (this.state.transcript || '').trim();
      if (!transcriptText) {
        this.props.showToast({ type: 'error', message: 'Please enter a transcript.', pos: 'bottom' });
        return false;
      }

      try {
        this.setState({ transcriptValidating: true });
        const { isDuplicate } = await checkTranscriptDuplicate(transcriptText);
        const ok = !isDuplicate;
        this.setState({ 
          transcriptValidated: !!ok,
          transcriptValidating: false,
          transcriptValidationMessage: ok ? 'Transcript is unique.' : 'Duplicate transcript detected. Please use a unique transcript.',
          transcriptSimilarityScore: null,
          transcriptLocked: !!ok
        });
        this.props.showToast({ 
          type: ok ? 'success' : 'error',
          message: ok ? 'Transcript is unique.' : 'Duplicate transcript detected. You cannot proceed with a duplicate transcript.',
          pos: 'bottom' 
        });
        return ok;
      } catch (err) {
        this.setState({ 
          transcriptValidating: false,
          transcriptValidated: false,
          transcriptLocked: false,
          transcriptValidationMessage: 'Transcript check failed. Please try again.'
        });
        this.props.showToast({ type: 'error', message: 'Transcript check failed. Please try again.', pos: 'bottom' });
        return false;
      }
    }

    // Determine the text that the test is based on for question-limit logic
    getLeadTextForQuestionLimit = () => {
      try {
        const useTranscript = this.state.hasAttachments && (this.state.transcript || '').trim() !== '';
        if (useTranscript) {
          return (this.state.transcript || '').trim();
        }
        const { thoughtData } = this.state;
        const possible = [
          thoughtData && (thoughtData.quote || thoughtData.content || thoughtData.description),
          this.props.title,
          this.props.data && this.props.data.title,
          this.props.itemData && this.props.itemData.title,
          this.props.leadData && this.props.leadData.title,
          this.props.thoughtData && this.props.thoughtData.title
        ].filter(Boolean);
        return String(possible[0] || '').trim();
      } catch (_) {
        return '';
      }
    };

    // Count words in a string
    countWords = (text) => {
      if (!text) return 0;
      const cleaned = String(text).replace(/\s+/g, ' ').trim();
      if (!cleaned) return 0;
      return cleaned.split(' ').length;
    };

    // Classify content length for enforcing question limits
    getContentLengthClass = (text) => {
      const words = this.countWords(text);
      // Heuristics: small paragraph <= 120 words; long content >= 300 words
      if (words >= 300) return 'long';
      if (words > 0 && words <= 120) return 'short';
      return 'normal';
    };

    // Show a modal dialog explaining rule violations
    showQuestionRuleViolation = ({ lengthClass, requestedTotal, wordCount }) => {
      const title = 'Question Limit Rule';
      const isShort = lengthClass === 'short';
      const message = isShort
        ? `Your transcript/lead is short (~${wordCount} words). Tests cannot exceed 5 questions.
Requested: ${requestedTotal}. Please reduce the number of questions and try again.`
        : `Your transcript/lead is long (~${wordCount} words). Tests must have at least 10 questions.
Requested: ${requestedTotal}. Please increase the number of questions and try again.`;

      // Use native alert to avoid duplicate React root issues from confirmAlert in this context
      alert(`${title}\n\n${message}`);
    };

    // Handle TestValidator dialog close
    handleTestValidatorClose = () => {
      this.setState({
        showTestValidator: false,
        testValidationData: null
      });
    };

    // Handle TestValidator submit (proceed with publishing)
    handleTestValidatorSubmit = () => {
      this.setState({
        showTestValidator: false,
        testValidationData: null
      }, () => {
        // Proceed with publishing the test
        this.allowExit();
        this.stop(0, null);
      });
    };

    // Load a question into the form for editing
    editQuestion = (questionIndex) => {
      const { sections, currentSection } = this.state;
      const question = sections[currentSection].questions[questionIndex];
      
      if (question) {
        this.setState({
          sQuestion: question.question || '',
          sAnswer1: question.a1 || '',
          sAnswer2: question.a2 || '',
          sAnswer3: question.a3 || '',
          sAnswer4: question.a4 || '',
          sAnswer5: question.a5 || '',
          editingQuestionIndex: questionIndex,
          showQuestionsList: false
        });
      }
    };

    // Update existing question (instead of adding new one)
    updateQuestion = () => {
      const { currentSection, sections, sQuestion, sAnswer1, sAnswer2, sAnswer3, sAnswer4, sAnswer5, editingQuestionIndex } = this.state;
      
      // Validate required fields
      if (!sQuestion.trim()) {
        alert('Please enter the question text before updating the question.');
        return;
      }

      // Check if at least 2 answers are provided
      const answers = [sAnswer1, sAnswer2, sAnswer3, sAnswer4].filter(answer => answer && answer.trim() !== '');
      if (answers.length < 2) {
        alert('Please provide at least 2 answer options before updating the question.');
        return;
      }

      if (!sAnswer5.trim()) {
        alert('Please enter the correct answer before updating the question.');
        return;
      }

      // Check if correct answer matches one of the provided options
      const providedAnswers = [sAnswer1, sAnswer2, sAnswer3, sAnswer4].filter(a => a && a.trim() !== '');
      if (!providedAnswers.includes(sAnswer5)) {
        alert('The correct answer must match exactly one of the provided answer options.');
        return;
      }

      const updatedQuestion = {
        id: sections[currentSection].questions[editingQuestionIndex].id,
        question: sQuestion,
        a1: sAnswer1,
        a2: sAnswer2,
        a3: sAnswer3,
        a4: sAnswer4,
        a5: sAnswer5
      };

      const updatedSections = [...sections];
      updatedSections[currentSection].questions[editingQuestionIndex] = updatedQuestion;

      this.setState({
        sections: updatedSections,
        sQuestion: '',
        sAnswer1: '',
        sAnswer2: '',
        sAnswer3: '',
        sAnswer4: '',
        sAnswer5: '',
        editingQuestionIndex: -1,
        showQuestionsList: true
      });
    };

    // Delete a question
    deleteQuestion = (questionIndex) => {
      if (window.confirm('Are you sure you want to delete this question? This action cannot be undone.')) {
        const { sections, currentSection } = this.state;
        const updatedSections = [...sections];
        updatedSections[currentSection].questions.splice(questionIndex, 1);
        
        // Re-assign IDs to maintain sequence
        updatedSections[currentSection].questions.forEach((question, index) => {
          question.id = index + 1;
        });

        this.setState({
          sections: updatedSections,
          editingQuestionIndex: -1,
          sQuestion: '',
          sAnswer1: '',
          sAnswer2: '',
          sAnswer3: '',
          sAnswer4: '',
          sAnswer5: ''
        });
      }
    };

    // Toggle questions list view
    toggleQuestionsList = () => {
      this.setState({
        showQuestionsList: !this.state.showQuestionsList
      });
    };

    // Cancel editing and clear form
    cancelEdit = () => {
      this.setState({
        sQuestion: '',
        sAnswer1: '',
        sAnswer2: '',
        sAnswer3: '',
        sAnswer4: '',
        sAnswer5: '',
        editingQuestionIndex: -1
      });
    };

    // Add question to current section or update existing question
    addQuestionToSection = () => {
      const { currentSection, sections, sQuestion, sAnswer1, sAnswer2, sAnswer3, sAnswer4, sAnswer5, maxQuestionsPerSection, editingQuestionIndex } = this.state;
      
      // If we're editing an existing question, call updateQuestion instead
      if (editingQuestionIndex >= 0) {
        this.updateQuestion();
        return;
      }
      
      // Check if transcript is required but not provided
      if (this.state.hasAttachments && (!this.state.transcript || this.state.transcript.trim() === '')) {
        this.props.showToast({
          type: 'error',
          message: 'Transcript is required for leads with attachments. Please provide a transcript before adding questions.',
          pos: 'bottom'
        });
        return;
      }
      
      // Check if section has reached the maximum question limit (only for new questions)
      if (sections[currentSection].questions.length >= maxQuestionsPerSection) {
        alert(`⚠️ This section already has the maximum of ${maxQuestionsPerSection} questions. Please switch to another section or create a new section to add more questions.`);
        return;
      }
      
      // Validate required fields
      if (!sQuestion.trim()) {
        alert('Please enter the question text before adding the question.');
        return;
      }

      // Check if at least 2 answers are provided
      const answers = [sAnswer1, sAnswer2, sAnswer3, sAnswer4].filter(answer => answer && answer.trim() !== '');
      if (answers.length < 2) {
        alert('Please provide at least 2 answer options before adding the question.');
        return;
      }

      if (!sAnswer5.trim()) {
        alert('Please enter the correct answer before adding the question.');
        return;
      }

      // Check if correct answer matches one of the provided options
      const providedAnswers = [sAnswer1, sAnswer2, sAnswer3, sAnswer4].filter(a => a && a.trim() !== '');
      if (!providedAnswers.includes(sAnswer5)) {
        alert('The correct answer must match exactly one of the provided answer options.');
        return;
      }

      const newQuestion = {
        id: (sections[currentSection].questions.length + 1),
        question: sQuestion,
        a1: sAnswer1,
        a2: sAnswer2,
        a3: sAnswer3,
        a4: sAnswer4,
        a5: sAnswer5
      };

      const updatedSections = [...sections];
      updatedSections[currentSection].questions.push(newQuestion);

      this.setState({
        sections: updatedSections,
        sQuestion: '',
        sAnswer1: '',
        sAnswer2: '',
        sAnswer3: '',
        sAnswer4: '',
        sAnswer5: '',
        showQuestionsList: true  // Show questions list after adding
      });
    };

    // Save current question if form has data before publishing
    saveCurrentQuestionIfExists = () => {
      // Check if there's a question currently being filled out
      const hasQuestionText = this.state.sQuestion && this.state.sQuestion.trim() !== '';
      const hasAtLeastTwoAnswers = [this.state.sAnswer1, this.state.sAnswer2, this.state.sAnswer3, this.state.sAnswer4]
                                   .filter(answer => answer && answer.trim() !== '').length >= 2;
      const hasCorrectAnswer = this.state.sAnswer5 && this.state.sAnswer5.trim() !== '';
      
      if (hasQuestionText && hasAtLeastTwoAnswers && hasCorrectAnswer) {
        // Check if section has reached the maximum question limit before auto-saving
        const { sections, currentSection, maxQuestionsPerSection } = this.state;
        if (sections[currentSection].questions.length >= maxQuestionsPerSection) {
          return false; // Cannot save question due to limit
        }
        
        // Create the question object
        const newQuestion = {
          question: this.state.sQuestion,
          a1: this.state.sAnswer1 || '',
          a2: this.state.sAnswer2 || '',
          a3: this.state.sAnswer3 || '',
          a4: this.state.sAnswer4 || '',
          a5: this.state.sAnswer5 || '' // Correct answer
        };
        
        // Add question to current section synchronously
        const updatedSections = [...sections];
        updatedSections[currentSection].questions.push(newQuestion);
        
        // Update state synchronously for validation
        this.setState({ 
          sections: updatedSections,
          // Clear form
          sQuestion: '',
          sAnswer1: '',
          sAnswer2: '',
          sAnswer3: '',
          sAnswer4: '',
          sAnswer5: ''
        });
        
        return true; // Question was saved
      }
      return false; // No question to save
    };

    // Handle publish test with auto-save of current question
    handlePublishTest = () => {
      // Check if there's a question currently being filled out
      const hasQuestionText = this.state.sQuestion && this.state.sQuestion.trim() !== '';
      const hasAtLeastTwoAnswers = [this.state.sAnswer1, this.state.sAnswer2, this.state.sAnswer3, this.state.sAnswer4]
                                   .filter(answer => answer && answer.trim() !== '').length >= 2;
      const hasCorrectAnswer = this.state.sAnswer5 && this.state.sAnswer5.trim() !== '';
      
      if (hasQuestionText && hasAtLeastTwoAnswers && hasCorrectAnswer) {
        // Check if section has reached the maximum question limit before auto-saving
        const { sections, currentSection, maxQuestionsPerSection } = this.state;
        if (sections[currentSection].questions.length >= maxQuestionsPerSection) {
          alert(`❌ Cannot publish: The current section "${sections[currentSection].name}" already has the maximum of ${maxQuestionsPerSection} questions. Please remove some questions or create a new section.`);
          return;
        }
        
        // Validate that correct answer matches one of the provided options
        const providedAnswers = [this.state.sAnswer1, this.state.sAnswer2, this.state.sAnswer3, this.state.sAnswer4]
                               .filter(a => a && a.trim() !== '');
        if (!providedAnswers.includes(this.state.sAnswer5)) {
          alert('❌ The correct answer must match exactly one of the provided answer options.');
          return;
        }
        
        // Create the question object
        const newQuestion = {
          question: this.state.sQuestion,
          a1: this.state.sAnswer1 || '',
          a2: this.state.sAnswer2 || '',
          a3: this.state.sAnswer3 || '',
          a4: this.state.sAnswer4 || '',
          a5: this.state.sAnswer5 || '' // Correct answer
        };
        
        // Add question to current section
        const updatedSections = [...sections];
        updatedSections[currentSection].questions.push(newQuestion);
        
        // Update state and then validate/publish
        this.setState({ 
          sections: updatedSections,
          // Clear form
          sQuestion: '',
          sAnswer1: '',
          sAnswer2: '',
          sAnswer3: '',
          sAnswer4: '',
          sAnswer5: ''
        }, () => {
          // Callback after state is updated - validate and show AI validation dialog
          if (this.validateSectionsForPublish()) {
            // Prepare test data for validation
            const testData = {
              sections: this.state.sections,
              title: this.state.stitle
            };
            
            // Open AI validation dialog
            this.setState({
              showTestValidator: true,
              testValidationData: testData
            });
          }
        });
      } else if (hasQuestionText || hasAtLeastTwoAnswers || hasCorrectAnswer) {
        // There's partial data - show specific error message
        if (!hasQuestionText) {
          alert('❌ Please enter the question text before publishing the test.');
          return;
        }
        if (!hasAtLeastTwoAnswers) {
          alert('❌ Please enter at least 2 answer options before publishing the test.');
          return;
        }
        if (!hasCorrectAnswer) {
          alert('❌ Please enter the correct answer before publishing the test.');
          return;
        }
      } else {
        // No current question to save, just validate and show AI validation
        if (this.validateSectionsForPublish()) {
          // Prepare test data for validation
          const testData = {
            sections: this.state.sections,
            title: this.state.stitle
          };
          
          // Open AI validation dialog
          this.setState({
            showTestValidator: true,
            testValidationData: testData
          });
        }
      }
    };

    // Validate that all sections have at least one question and all questions are complete
    validateSectionsForPublish = () => {
      const { sections } = this.state;
      
      // Check for empty sections
      const emptySections = sections.filter(section => section.questions.length === 0);
      if (emptySections.length > 0) {
        const emptyNames = emptySections.map(s => s.name).join(', ');
        alert(`Please add at least one question to each section. Empty sections: ${emptyNames}`);
        return false;
      }
      
      // Validate each question in each section
      for (let section of sections) {
        for (let question of section.questions) {
          // Check if question text exists
          if (!question.question || question.question.trim() === '') {
            alert(`All questions in section "${section.name}" must have question text.`);
            return false;
          }
          
          // Check if at least 2 answers are provided
          const answers = [question.a1, question.a2, question.a3, question.a4].filter(a => a && a.trim() !== '');
          if (answers.length < 2) {
            alert(`All questions must have at least 2 answer options. Check section "${section.name}".`);
            return false;
          }
          
          // Check if correct answer is provided
          if (!question.a5 || question.a5.trim() === '') {
            alert(`All questions must have a correct answer selected. Check section "${section.name}".`);
            return false;
          }
        }
      }
      
      // Validate minimum questions based on test difficulty
      const totalQuestions = sections.reduce((sum, section) => sum + section.questions.length, 0);

      // Enforce content-length-based limits early in manual publish flow
      const contentForLimits = this.getLeadTextForQuestionLimit();
      const lengthClass = this.getContentLengthClass(contentForLimits);
      if ((lengthClass === 'long' && totalQuestions < 10) || (lengthClass === 'short' && totalQuestions > 5)) {
        this.showQuestionRuleViolation({ lengthClass, requestedTotal: totalQuestions, wordCount: this.countWords(contentForLimits) });
        return false;
      }
      const testDifficulty = this.state.aiTestConfig?.difficulty || this.state.testComplexity || 'basic';
      
      const validation = validateMinimumQuestions(totalQuestions, testDifficulty);
      if (!validation.isValid) {
        const difficultyInfo = getDifficultyInfo(testDifficulty);
        alert(
          `❌ Test Creation Failed\n\n` +
          `${validation.message}\n\n` +
          `📊 Current test: ${totalQuestions} question${totalQuestions === 1 ? '' : 's'}\n` +
          `🎯 ${difficultyInfo.displayName} difficulty requires: ${validation.minRequired} question${validation.minRequired === 1 ? '' : 's'}\n\n` +
          `Please add ${validation.minRequired - totalQuestions} more question${validation.minRequired - totalQuestions === 1 ? '' : 's'} to meet the minimum requirement.`
        );
        return false;
      }

      // If attachments are present, ensure a transcript is provided and valid before allowing manual publish
      if (this.state.hasAttachments) {
        if (!this.state.transcript || this.state.transcript.trim() === '') {
          alert('❌ This lead contains attachments, so a transcript is required to ensure test relevance. Please add a transcript.');
          return false;
        }
      }
      
      return true;
    };

    // Handle section change and clear form
    handleSectionChange = (newSectionIndex) => {
      this.setState({
        currentSection: newSectionIndex
      }, () => {
        this.clearQuestionForm();
      });
    };

    // NEW: LC reward for publishing a test (admin-controlled level)
    calculateLCReward = () => {
      try {
        const { getActiveLcSettings } = require('../../utils/lc_settings');
        const s = getActiveLcSettings();
        return Number(s.testCreationLc || 0.07);
      } catch (e) {
        return 0.07;
      }
    };

    // Enhanced existing functions
    makeid(length) {
      var result           = '';
      var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * 
    charactersLength));
      }
      return result;
    }

    checkAnswers = (qqNum) => {
      if (qqNum === 0) { answerIn = true }
      else
      {
      var answerIn = false;
      if (
        this.state.sAnswer5 !== this.state.sAnswer1 &&
        this.state.sAnswer5 !== this.state.sAnswer2 &&
        this.state.sAnswer5 !== this.state.sAnswer3 &&
        this.state.sAnswer5 !== this.state.sAnswer4 
       )
       {
        answerIn = false;
       }
       else
       {
        answerIn = true;
       }
       if (
        this.state.sAnswer1 === '' || 
        this.state.sAnswer2 === '' || 
        this.state.sAnswer3 === '' || 
        this.state.sAnswer4 === '' || 
        this.state.sAnswer5 === ''   
       ) 
       {
        answerIn = false;
       }
      }
       return answerIn;
     }

    // Enhanced stop function with new features
    stop = async (nrIn, val) => {
      // Calculate final LC reward
      const finalLCReward = this.calculateLCReward();
      
      // Calculate total questions across all sections
      const totalQuestions = this.state.sections.reduce((sum, section) => sum + section.questions.length, 0);
      
      // Enforce content-length-based limits for manual test creation
      const contentForLimits = this.getLeadTextForQuestionLimit();
      const lengthClass = this.getContentLengthClass(contentForLimits);
      if (lengthClass === 'long' && totalQuestions < 10) {
        this.showQuestionRuleViolation({ lengthClass, requestedTotal: totalQuestions, wordCount: this.countWords(contentForLimits) });
        return;
      }
      if (lengthClass === 'short' && totalQuestions > 5) {
        this.showQuestionRuleViolation({ lengthClass, requestedTotal: totalQuestions, wordCount: this.countWords(contentForLimits) });
        return;
      }
      
      // Convert sections to the old format for backward compatibility
      let questionsData = {};
      let questionIndex = 1;
      
      this.state.sections.forEach(section => {
        section.questions.forEach(question => {
          // Ensure all fields have valid values, not undefined
          questionsData[`QandA${questionIndex}`] = {
            question: question.question || '',
            a1: question.a1 || '',
            a2: question.a2 || '',
            a3: question.a3 || '',
            a4: question.a4 || '',
            a5: question.a5 || '',
            sectionId: section.id || 'default',
            sectionName: section.name || 'Section'
          };
          questionIndex++;
        });
      });
      

      
      // Clean sections data to remove any undefined values
      const cleanSections = this.state.sections.map(section => ({
        id: section.id || 'default',
        name: section.name || 'Section',
        questions: section.questions.map(q => ({
          question: q.question || '',
          a1: q.a1 || '',
          a2: q.a2 || '',
          a3: q.a3 || '',
          a4: q.a4 || '',
          a5: q.a5 || ''
        }))
      }));
      
      var body = {
        thoughtID: this.props.thoughtID,
        type: SURVEY_LIST,
        title: this.state.stitle,
        companyID: this.state.companyid,
        typeofSurvey: this.state.typeofsurvey,
        size: totalQuestions,
        // Enhanced with new structure
        sections: cleanSections,
        testComplexity: this.state.testComplexity || 'basic',
        categoryType: this.state.categoryType || 'general',
        estimatedLCReward: finalLCReward,
        ...questionsData,
        ownMaterial: this.state.ownMaterial,
        dailyThoughtType: this.props.dailyThoughtType,
        groupid: this.props.groupid
      };

      
      // If transcript is used, persist its excerpt before creating survey
      const usingTranscript = this.state.hasAttachments && (this.state.transcript || '').trim();
      const doCreate = () => this.props.createSurvey(body);
      if (usingTranscript) {
        try {
          const transcriptText = (this.state.transcript || '').trim();
          const meta = { surveyid: this.props.thoughtID, companyID: this.state.companyid, source: 'manual' };
          const { key, excerpt, isDuplicate } = await checkTranscriptDuplicate(transcriptText);
          if (isDuplicate) {
            alert('❌ Duplicate transcript detected. You cannot proceed with a duplicate transcript.');
            return;
          }
          await saveTranscriptExcerpt(key, excerpt, meta);
        } catch (_e) {
          this.props.showToast({ type: 'warning', message: 'Could not persist transcript excerpt. Proceeding.', pos: 'bottom' });
        }
      }
      doCreate();
  
      // Allow exit after successful manual publish
      this.allowExit();

      this.setState({stitle: "", typeofsurvey: 0, Qnumber: 1000});

      // Enhanced points with dynamic LC calculation (support decimals)
      let pointsToAdd = 7; // default safety
      try {
        const { POINTS_PER_LC } = require('../../utils/lc_settings');
        pointsToAdd = Number((finalLCReward * POINTS_PER_LC).toFixed(3));
      } catch (e) {
        pointsToAdd = Number((finalLCReward * 100).toFixed(3));
      }
      
      if (this.state.ownMaterial==="true") {
        var params = {
          uid: this.props.userdata.uid,
          userID: this.props.userdata.userID,
          pointsCurrent: this.props.userdata.points,
          pointsAdded: pointsToAdd,
          ypointsCurrent: this.props.userdata.pointsy,
          trailID: this.makeid(10),
          companyName: this.props.userdata.companyName,
          firstName: this.props.userdata.firstName,
          lastName: this.props.userdata.lastName,
          title: this.state.stitle || 'Test',
          actionType: `Forum Test Published (${finalLCReward.toFixed(2)} LC earned)`,
          actionDesc: `${this.state.stitle} - ${this.state.sections.length} sections, ${totalQuestions} questions`,
          forceAward: true
        }

      }
      else
      {
        var params = {
          uid: this.props.userdata.uid,
          userID: this.props.userdata.userID,
          pointsCurrent: this.props.userdata.points,
          ypointsCurrent: this.props.userdata.pointsy,
          pointsAdded: pointsToAdd,
          trailID: this.makeid(10),
          companyName: this.props.userdata.companyName,
          firstName: this.props.userdata.firstName,
          lastName: this.props.userdata.lastName,
          title: this.state.stitle || 'Test',
          actionType: `Forum Test Published (${finalLCReward.toFixed(2)} LC earned)`,
          actionDesc: `${this.state.stitle} - ${this.state.sections.length} sections, ${totalQuestions} questions`,
          forceAward: true
        }
      }
     if (this.props.userdata.execmember===true) {
         this.props.addMorePoints(params);
     }
    this.props.getSurveyStage(this.props.thoughtID);
    this.props.resetMakeTest(this.props.thoughtID, this.props.companyID, this.props.companyID);

    if (this.props.showLeadb) {
      this.props.showLeadb(this.props, 'something');
      }	
      return <div>-------</div>
    }
  
    handleChangev = (name, value) => {
      if(value==null) {
         return;
      }
      this.setState({
        [name]: value
      });
      }     

      handleNameChange = event => {
        this.setState({ sAnswer1: event.target.value });
      };

      handleChangex = (val) => {
        this.setState({
          sAnswer1: val
        });
      };

      setVal = (txtIn, vv) => {
        this.setState({
          [txtIn]: vv,
        });
      };

    changeDetails = e => {
      const { name, value, checked, maxLength } = e.target;
      const { Details, formErrors } = this.state;
      let formObj = {};
      if (name === "sAnswer1") {
        // handle the change event of sAnswer1
          // push selected value in list
          this.setState({
            [name]: this.inputRef.value,
          });
        // handle change event except language field
        // this.setState({
        //   [name]: value
        // });
      }
    };
    // confirmPublish = () => {
    //   // inside confirmPublish
    //   confirmAlert({
    //     title: 'Confirm Test Publication',
    //     message: 'Are you sure that you want to publish this test?',
    //     buttons: [
    //       {
    //         label: 'Yes',
    //         onClick: () => alert('Click Yes')
    //       },
    //       {
    //         label: 'No',
    //         onClick: () => alert('Click No')
    //       }
    //     ]
    //   });
    // };

    getMobileOperatingSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
          return "Windows Phone";
      }
  
      if (/android/i.test(userAgent)) {
          return "Android";
      }
  
      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return "iOS";
      }
  
      return "unknown";
  }

    submitPost = (desc) => {

      var pass = true;
      var limit = true;

    if (desc===1 && this.state.Qnumber===7) {  //reached limit of 8 questions
     // green getMobileOperatingSystem check

      if(this.getMobileOperatingSystem==='iOS') {
          desc = 2;

          pass = true;
      }
      else
      {
          if (window.confirm('Seven questions is your limit. Do you want to save your Test now?')) {
          // Save it!
          desc = 2;
          pass = true;
           
          } else {
          // Do nothing!
          pass = false;
           
          }
        } 
      }

      // if (desc===1 && this.state.Qnumber===7) {  //reached limit of 8 questions
      //   if (window.confirm('Seven questions is your limit. Do you want to save your Test now?')) {
      //   // Save it!
      //   desc = 2;
      //   Thing was saved to the database.
      //   pass = true;
         
      //   } else {
      //   // Do nothing!
      //   Thing was not saved to the database.
      //   pass = false;
         
      //   }
      // }   

            ///////////GO BACK///////GO BACK/////////////////////////////////////

            var qq;
          if (desc===3) {                                           ///going back
            qq = this.state.Qnumber - 1

            switch (qq) {
              case 1:
                params = {
                  type: TEST_HISTORY,
                  q: this.state.QandA1.question,
                  a1: this.state.QandA1.a1,
                  a2: this.state.QandA1.a2,
                  a3: this.state.QandA1.a3,
                  a4: this.state.QandA1.a4,
                  a5: this.state.QandA1.a5
                }
                this.props.testHistoryActions(params);


                break;
              case 2:
                  params = {
                    type: TEST_HISTORY,
                    q: this.state.QandA2.question,
                    a1: this.state.QandA2.a1,
                    a2: this.state.QandA2.a2,
                    a3: this.state.QandA2.a3,
                    a4: this.state.QandA2.a4,
                    a5: this.state.QandA2.a5
                  }
                  this.props.testHistoryActions(params);
                  break;
               case 3:
                  params = {
                    type: TEST_HISTORY,
                    q: this.state.QandA3.question,
                    a1: this.state.QandA3.a1,
                    a2: this.state.QandA3.a2,
                    a3: this.state.QandA3.a3,
                    a4: this.state.QandA3.a4,
                    a5: this.state.QandA3.a5
                  }
                  this.props.testHistoryActions(params);
                  break;    
               case 4:
                  params = {
                    type: TEST_HISTORY,
                    q: this.state.QandA4.question,
                    a1: this.state.QandA4.a1,
                    a2: this.state.QandA4.a2,
                    a3: this.state.QandA4.a3,
                    a4: this.state.QandA4.a4,
                    a5: this.state.QandA4.a5
                  }
                  this.props.testHistoryActions(params);
                  break;   
               case 5:
                    params = {
                      type: TEST_HISTORY,
                      q: this.state.QandA5.question,
                      a1: this.state.QandA5.a1,
                      a2: this.state.QandA5.a2,
                      a3: this.state.QandA5.a3,
                      a4: this.state.QandA5.a4,
                      a5: this.state.QandA5.a5
                    }
                    this.props.testHistoryActions(params);
                    break;                               
              default:
              }
            }
              if (desc===1) {                                      ///  navigating forward
                qq = this.state.Qnumber + 1

                switch (qq) {
                  case 1:
                    params = {
                      type: TEST_HISTORY,
                      q: this.state.QandA1.question,
                      a1: this.state.QandA1.a1,
                      a2: this.state.QandA1.a2,
                      a3: this.state.QandA1.a3,
                      a4: this.state.QandA1.a4,
                      a5: this.state.QandA1.a5
                    }
                    this.props.testHistoryActions(params);
    

                    break;
                  case 2:
                      params = {
                        type: TEST_HISTORY,
                        q: this.state.QandA2.question,
                        a1: this.state.QandA2.a1,
                        a2: this.state.QandA2.a2,
                        a3: this.state.QandA2.a3,
                        a4: this.state.QandA2.a4,
                        a5: this.state.QandA2.a5
                      }
                      this.props.testHistoryActions(params);
                      break;
                   case 3:
                      params = {
                        type: TEST_HISTORY,
                        q: this.state.QandA3.question,
                        a1: this.state.QandA3.a1,
                        a2: this.state.QandA3.a2,
                        a3: this.state.QandA3.a3,
                        a4: this.state.QandA3.a4,
                        a5: this.state.QandA3.a5
                      }
                      this.props.testHistoryActions(params);
                      break;    
                   case 4:
                      params = {
                        type: TEST_HISTORY,
                        q: this.state.QandA4.question,
                        a1: this.state.QandA4.a1,
                        a2: this.state.QandA4.a2,
                        a3: this.state.QandA4.a3,
                        a4: this.state.QandA4.a4,
                        a5: this.state.QandA4.a5
                      }
                      this.props.testHistoryActions(params);
                      break;   
                   case 5:
                        params = {
                          type: TEST_HISTORY,
                          q: this.state.QandA5.question,
                          a1: this.state.QandA5.a1,
                          a2: this.state.QandA5.a2,
                          a3: this.state.QandA5.a3,
                          a4: this.state.QandA5.a4,
                          a5: this.state.QandA5.a5
                        }
                        this.props.testHistoryActions(params);
                        break;                               
                  default:
                  }  
                }       
            //}
            //////////////////////////////////////////////////////////////////////

      if (desc===2) {
        if (this.checkAnswers(this.state.Qnumber) === false) {
          //back out
          var params = {
            type: SHOW_TOAST,
            open: true,
            variant: 'warning',
            message: 'You did not fill in all the fields, or your correct answer in the last text field does NOT CORRESPOND with any of the other fields 1 to 4. Please try again.'
          }
          this.props.showToast(params)
          return
        }
        if (window.confirm('Are you sure you want to publish this test? Confirming will be final, and your test will then be published.')) {
        // Save it!

        pass = true;
        } else {
        // Do nothing!
        pass = false;
        }
      }
      if (pass===true) {
      if (this.checkAnswers(this.state.Qnumber) === false && desc===1) {
        //back out

        var params = {
          type: SHOW_TOAST,
          open: true,
          variant: 'warning',
          message: 'You did not fill in all the fields, or your correct answer in the last text field does NOT CORRESPOND with any of the other fields 1 to 4. Please try again.'
        }
        this.props.showToast(params)
        return
      }
      var arrAnswer1 = [];
      var arrAnswer2 = [];
      var arrAnswer3 = [];
      var arrAnswer4 = [];
      var arrAnswer5 = [];
      var arrAnswer6 = []; 
      var arrAnswer7 = [];
      var arrAnswer8 = [];
      var arrAnswer9 = [];
      var arrAnswer10 = [];
      var arrAnswer11 = [];
      var arrAnswer12 = [];
      var arrQandA = [];
  

     if (desc===2) {
      var qq = this.state.Qnumber + 1;
     }
  
     this.setState({Qnumber: qq});
     var arrQandA = []; //{}; //new Array();
     var arrAnswer = []; //{};
     var Qnum = this.state.Qnumber;
     var lastQ;
  
    //  if (desc === 2) {
    //    Qnum = 12
  
    //   }


     switch (Qnum) {
      case 1000:

        break;
      case 0: // survey basic details
        this.setState({
          title: this.state.stitle,
          companyID: this.state.companyid 
        })
        break;
      case 1: // build arrays for all other cases
      arrAnswer1 = {
        "question": this.state.sQuestion,
        "a1": this.state.sAnswer1,
        "a2": this.state.sAnswer2,
        "a3": this.state.sAnswer3,
        "a4": this.state.sAnswer4,
        "a5": this.state.sAnswer5
      };
      this.setState({QandA1: arrAnswer1});
      if ( desc === 2 && Qnum === 1 ) {
        this.stop(1, arrAnswer1)
      }
        break;
      case 2: // build arrays for all other cases
      arrAnswer2 = {
        "question": this.state.sQuestion,
        "a1": this.state.sAnswer1,
        "a2": this.state.sAnswer2,
        "a3": this.state.sAnswer3,
        "a4": this.state.sAnswer4,
        "a5": this.state.sAnswer5
      };
      this.setState({QandA2: arrAnswer2});

      if ( desc === 2 && Qnum === 2 ) {
        this.stop(2, arrAnswer2)
      }
        break;
      case 3: // build arrays for all other cases
      arrAnswer3 = {
        "question": this.state.sQuestion,
        "a1": this.state.sAnswer1,
        "a2": this.state.sAnswer2,
        "a3": this.state.sAnswer3,
        "a4": this.state.sAnswer4,
        "a5": this.state.sAnswer5
      };
      if ( desc === 2 && Qnum === 3 ) {
        this.stop(3, arrAnswer3)
      }
      this.setState({QandA3: arrAnswer3});
        break; 
      case 4: // build arrays for all other cases
      arrAnswer4 = {
        "question": this.state.sQuestion,
        "a1": this.state.sAnswer1,
        "a2": this.state.sAnswer2,
        "a3": this.state.sAnswer3,
        "a4": this.state.sAnswer4,
        "a5": this.state.sAnswer5
      };
      this.setState({QandA4: arrAnswer4});
      if ( desc === 2 && Qnum === 4 ) {
        this.stop(4, arrAnswer4)
      }
        break;  
     case 5: // build arrays for all other cases
      arrAnswer5 = {
        "question": this.state.sQuestion,
        "a1": this.state.sAnswer1,
        "a2": this.state.sAnswer2,
        "a3": this.state.sAnswer3,
        "a4": this.state.sAnswer4,
        "a5": this.state.sAnswer5
      };
      this.setState({QandA5: arrAnswer5});
      if ( desc === 2 && Qnum === 5 ) {
        this.stop(5, arrAnswer5)
      }
        break;    
     case 6: // build arrays for all other cases
        arrAnswer6 = {
          "question": this.state.sQuestion,
          "a1": this.state.sAnswer1,
          "a2": this.state.sAnswer2,
          "a3": this.state.sAnswer3,
          "a4": this.state.sAnswer4,
          "a5": this.state.sAnswer5
        };
        this.setState({QandA6: arrAnswer6});
        if ( desc === 2 && Qnum === 6 ) {
          this.stop(6, arrAnswer6)
        }
          break;      
     case 7: // build arrays for all other cases
          arrAnswer7 = {
            "question": this.state.sQuestion,
            "a1": this.state.sAnswer1,
            "a2": this.state.sAnswer2,
            "a3": this.state.sAnswer3,
            "a4": this.state.sAnswer4,
            "a5": this.state.sAnswer5
          };
          this.setState({QandA7: arrAnswer7});
          if ( desc === 2 && Qnum === 7 ) {
            this.stop(7, arrAnswer7)
          }
            break;       
     case 8: // build arrays for all other cases
            arrAnswer8 = {
              "question": this.state.sQuestion,
              "a1": this.state.sAnswer1,
              "a2": this.state.sAnswer2,
              "a3": this.state.sAnswer3,
              "a4": this.state.sAnswer4,
              "a5": this.state.sAnswer5
            };
            this.setState({QandA8: arrAnswer8});
            if ( desc === 2 && Qnum === 8 ) {
              this.stop(8, arrAnswer8)
            }
              break; 
     case 9: // build arrays for all other cases
            arrAnswer9 = {
              "question": this.state.sQuestion,
              "a1": this.state.sAnswer1,
              "a2": this.state.sAnswer2,
              "a3": this.state.sAnswer3,
              "a4": this.state.sAnswer4,
              "a5": this.state.sAnswer5
            };
            this.setState({QandA9: arrAnswer9});
            if ( desc === 2 && Qnum === 9 ) {
              this.stop(9, arrAnswer9)
            }
              break; 
      case 10: // build arrays for all other cases
            arrAnswer10 = {
              "question": this.state.sQuestion,
              "a1": this.state.sAnswer1,
              "a2": this.state.sAnswer2,
              "a3": this.state.sAnswer3,
              "a4": this.state.sAnswer4,
              "a5": this.state.sAnswer5
            };
            this.setState({QandA10: arrAnswer10});
            if ( desc === 2 && Qnum === 10 ) {
              this.stop(10, arrAnswer10)
            }
              break; 
       case 11: // build arrays for all other cases
              arrAnswer11 = {
                "question": this.state.sQuestion,
                "a1": this.state.sAnswer1,
                "a2": this.state.sAnswer2,
                "a3": this.state.sAnswer3,
                "a4": this.state.sAnswer4,
                "a5": this.state.sAnswer5
              };
              this.setState({QandA11: arrAnswer11});
              if ( desc === 2 && Qnum === 11 ) {
                this.stop(11, arrAnswer11)
              }
                break;              
      case 12: // last question, submit all 
        arrAnswer12 = {
          "question": this.state.c,
          "a1": this.state.sAnswer1,
          "a2": this.state.sAnswer2,
          "a3": this.state.sAnswer3,
          "a4": this.state.sAnswer4,
          "a5": this.state.sAnswer5
        };
        this.setState({QandA12: arrAnswer12});
        if ( desc === 2 && Qnum === 12 ) {
          this.stop(12, arrAnswer12)
        }
        // lastQ = "QandA" + this.state.Qnumber
        // this.setState({[lastQ]: arrAnswer12});
        // if (this.state.Qnumber != 12) {arrAnswer12=[]}
  
        // var body = {
        //   type: SURVEY_LIST,
        //   title: this.state.stitle,
        //   companyID: this.state.companyid,
        //   typeofSurvey: this.state.typeofsurvey,
        //   size: this.state.Qnumber,
        //   QandA1: this.state.QandA1,
        //   QandA2: this.state.QandA2,
        //   QandA3: this.state.QandA3,
        //   QandA4: this.state.QandA4,
        //   QandA5: this.state.QandA5,
        //   QandA6: this.state.QandA6,
        //   QandA7: this.state.QandA7,
        //   QandA8: this.state.QandA8,
        //   QandA9: this.state.QandA9,
        //   QandA10: this.state.QandA10,
        //   QandA11: this.state.QandA11,
        //   QandA12: arrAnswer12
        // };
  
        // body data
        // this.props.props.createSurvey(body);
  
        // this.setState({stitle: "", typeofsurvey: 0, Qnumber: 1000});
        // this.props.letgoPic(true);
        break;
  
      default: // build arrays for all other cases
     }
    //  this.setState({
    //   sQuestion: this.state.sQuestion ? this.state.sQuestion : '',
    //   sAnswer1: this.state.sAnswer1 ? this.state.sAnswer1 : '',
    //   sAnswer2: this.state.sAnswer2 ? this.state.sAnswer2 : '',
    //   sAnswer3: this.state.sAnswer3 ? this.state.sAnswer3 : '',
    //   sAnswer4: this.state.sAnswer4 ? this.state.sAnswer4 : '',
    //   sAnswer5: this.state.sAnswer5 ? this.state.sAnswer5 : '',
    //  });

    //  this.setState({
    //   sQuestion: this.state.arrAnswer1.question ? this.state.arrAnswer1.question : '',
    //   sAnswer1: this.state.arrAnswer1.a1 ? this.state.arrAnswer1.a1 : '',
    //   sAnswer2: this.state.arrAnswer2.a2 ? this.state.arrAnswer2.a2 : '',
    //   sAnswer3: this.state.arrAnswer3.a3 ? this.state.arrAnswer3.a3 : '',
    //   sAnswer4: this.state.arrAnswer4.a4 ? this.state.arrAnswer4.a4 : '',
    //   sAnswer5: this.state.arrAnswer5.a5 ? this.state.arrAnswer5.a5 : '',
    //  });

    
    switch (qq) {
      case 1:

        this.setState({
          sQuestion: this.state.QandA1.question ? this.state.QandA1.question : '',
          sAnswer1: this.state.QandA1.a1 ? this.state.QandA1.a1 : '',
          sAnswer2: this.state.QandA1.a2 ? this.state.QandA1.a2 : '',
          sAnswer3: this.state.QandA1.a3 ? this.state.QandA1.a3 : '',
          sAnswer4: this.state.QandA1.a4 ? this.state.QandA1.a4 : '',
          sAnswer5: this.state.QandA1.a5 ? this.state.QandA1.a5 : '',
         });
        break;
      case 2:

        this.setState({
          sQuestion: this.state.QandA2.question ? this.state.QandA2.question : '',
          sAnswer1: this.state.QandA2.a1 ? this.state.QandA2.a1 : '',
          sAnswer2: this.state.QandA2.a2 ? this.state.QandA2.a2 : '',
          sAnswer3: this.state.QandA2.a3 ? this.state.QandA2.a3 : '',
          sAnswer4: this.state.QandA2.a4 ? this.state.QandA2.a4 : '',
          sAnswer5: this.state.QandA2.a5 ? this.state.QandA2.a5 : '',
         });
        break;
      case 3:

        this.setState({
          sQuestion: this.state.QandA3.question ? this.state.QandA3.question : '',
          sAnswer1: this.state.QandA3.a1 ? this.state.QandA3.a1 : '',
          sAnswer2: this.state.QandA3.a2 ? this.state.QandA3.a2 : '',
          sAnswer3: this.state.QandA3.a3 ? this.state.QandA3.a3 : '',
          sAnswer4: this.state.QandA3.a4 ? this.state.QandA3.a4 : '',
          sAnswer5: this.state.QandA3.a5 ? this.state.QandA3.a5 : '',
         });
        break;  
      case 4:

        this.setState({
          sQuestion: this.state.QandA4.question ? this.state.QandA4.question : '',
          sAnswer1: this.state.QandA4.a1 ? this.state.QandA4.a1 : '',
          sAnswer2: this.state.QandA4.a2 ? this.state.QandA4.a2 : '',
          sAnswer3: this.state.QandA4.a3 ? this.state.QandA4.a3 : '',
          sAnswer4: this.state.QandA4.a4 ? this.state.QandA4.a4 : '',
          sAnswer5: this.state.QandA4.a5 ? this.state.QandA4.a5 : '',
         });
        break;   
      case 5:
        this.setState({
          sQuestion: this.state.QandA5.question ? this.state.QandA5.question : '',
          sAnswer1: this.state.QandA5.a1 ? this.state.QandA5.a1 : '',
          sAnswer2: this.state.QandA5.a2 ? this.state.QandA5.a2 : '',
          sAnswer3: this.state.QandA5.a3 ? this.state.QandA5.a3 : '',
          sAnswer4: this.state.QandA5.a4 ? this.state.QandA5.a4 : '',
          sAnswer5: this.state.QandA5.a5 ? this.state.QandA5.a5 : '',
          });
        break;   
      case 6:
        this.setState({
          sQuestion: this.state.QandA6.question ? this.state.QandA6.question : '',
          sAnswer1: this.state.QandA6.a1 ? this.state.QandA6.a1 : '',
          sAnswer2: this.state.QandA6.a2 ? this.state.QandA6.a2 : '',
          sAnswer3: this.state.QandA6.a3 ? this.state.QandA6.a3 : '',
          sAnswer4: this.state.QandA6.a4 ? this.state.QandA6.a4 : '',
          sAnswer5: this.state.QandA6.a5 ? this.state.QandA6.a5 : '',
          });
        break;   
      case 7:
        this.setState({
          sQuestion: this.state.QandA7.question ? this.state.QandA7.question : '',
          sAnswer1: this.state.QandA7.a1 ? this.state.QandA7.a1 : '',
          sAnswer2: this.state.QandA7.a2 ? this.state.QandA7.a2 : '',
          sAnswer3: this.state.QandA7.a3 ? this.state.QandA7.a3 : '',
          sAnswer4: this.state.QandA7.a4 ? this.state.QandA7.a4 : '',
          sAnswer5: this.state.QandA7.a5 ? this.state.QandA7.a5 : '',
          });
        break;   
      case 8:
        this.setState({
          sQuestion: this.state.QandA8.question ? this.state.QandA8.question : '',
          sAnswer1: this.state.QandA8.a1 ? this.state.QandA8.a1 : '',
          sAnswer2: this.state.QandA8.a2 ? this.state.QandA8.a2 : '',
          sAnswer3: this.state.QandA8.a3 ? this.state.QandA8.a3 : '',
          sAnswer4: this.state.QandA8.a4 ? this.state.QandA8.a4 : '',
          sAnswer5: this.state.QandA8.a5 ? this.state.QandA8.a5 : '',
          });
        break;  
      case 9:
        this.setState({
          sQuestion: this.state.QandA9.question ? this.state.QandA9.question : '',
          sAnswer1: this.state.QandA9.a1 ? this.state.QandA9.a1 : '',
          sAnswer2: this.state.QandA9.a2 ? this.state.QandA9.a2 : '',
          sAnswer3: this.state.QandA9.a3 ? this.state.QandA9.a3 : '',
          sAnswer4: this.state.QandA9.a4 ? this.state.QandA9.a4 : '',
          sAnswer5: this.state.QandA9.a5 ? this.state.QandA9.a5 : '',
          });
        break;   
      case 10:
        this.setState({
          sQuestion: this.state.QandA10.question ? this.state.QandA10.question : '',
          sAnswer1: this.state.QandA10.a1 ? this.state.QandA10.a1 : '',
          sAnswer2: this.state.QandA10.a2 ? this.state.QandA10.a2 : '',
          sAnswer3: this.state.QandA10.a3 ? this.state.QandA10.a3 : '',
          sAnswer4: this.state.QandA10.a4 ? this.state.QandA10.a4 : '',
          sAnswer5: this.state.QandA10.a5 ? this.state.QandA10.a5 : '',
          });
        break;  
      case 11:
        this.setState({
          sQuestion: this.state.QandA11.question ? this.state.QandA11.question : '',
          sAnswer1: this.state.QandA11.a1 ? this.state.QandA11.a1 : '',
          sAnswer2: this.state.QandA11.a2 ? this.state.QandA11.a2 : '',
          sAnswer3: this.state.QandA11.a3 ? this.state.QandA11.a3 : '',
          sAnswer4: this.state.QandA11.a4 ? this.state.QandA11.a4 : '',
          sAnswer5: this.state.QandA11.a5 ? this.state.QandA11.a5 : '',
          });
        break;                                  
    }
    // this.setState({
    //   sQuestion: '',
    //   sAnswer1: '',
    //   sAnswer2: '',
    //   sAnswer3: '',
    //   sAnswer4: '',
    //   sAnswer5: '',
    //  });
    }
  }

      componentDidMount() {
   // Extract thought data from props first
   this.fetchThoughtData();
   
  if (this.state.useAIGeneration) {
    this.syncAIConfigWithManualSections();
  }

   // Then extract lead context
   const leadContext = this.extractLeadContext();
   this.setState({
     defaultsurvey: "Select Survey Type",
     leadContext: leadContext
   });
   
   // Mark AI Test creation as active to prevent external refreshes
   try { localStorage.setItem('AI_TEST_ACTIVE', '1'); } catch (_) {}
   
   // Warn before tab/window close while building a test
   window.addEventListener('beforeunload', this.handleBeforeUnload);

  // Install strong navigation guards while building tests
  this.installNavigationGuards();

   // Disabled: do not lock difficulty during test creation (builder)
   // this.checkExistingTestAttempt();
  }
    
    componentDidUpdate(prevProps, prevState) {
      // Re-fetch thought data only when relevant inputs change
      const thoughtIdChanged = prevProps.thoughtID !== this.props.thoughtID;
      const thoughtsArraysChanged =
        prevProps.thoughtsData !== this.props.thoughtsData ||
        prevProps.thoughts !== this.props.thoughts;

      if (thoughtIdChanged || (thoughtsArraysChanged && !this.state.thoughtData)) {
        this.fetchThoughtData();
      }

      // Recompute lead context when its inputs change
      const leadInputsChanged =
        thoughtIdChanged ||
        prevState.thoughtData !== this.state.thoughtData ||
        prevProps.title !== this.props.title ||
        prevProps.data !== this.props.data ||
        prevProps.itemData !== this.props.itemData ||
        prevProps.leadData !== this.props.leadData ||
        prevProps.thoughtData !== this.props.thoughtData;

      if (leadInputsChanged) {
        const newLeadContext = this.extractLeadContext();
        if (JSON.stringify(newLeadContext) !== JSON.stringify(this.state.leadContext)) {
          this.setState({ leadContext: newLeadContext });
        }
      }
    }
    
    shouldComponentUpdate(nextProps, nextState) {
      return true;
    }
    handleSelection(){

    }

    // toggleOff(n) {
    //   const { ownMaterial, startPublish } = this.state
    //   green ownMaterial check
    //   this.setState({
    //     ownMaterial: n,
    //     startPublish: true
    //   })
    // };

    // onOptionSelect = (value) => {
    //   green Selected value check
    // }

    handleRadioChange = e => {
      const { name, value } = e.target;

      this.setState({
        ownMaterial: value,
        startPublish: true
      });
    };

    // AI Test Generation Methods
    toggleAIGeneration = () => {
      this.setState(prevState => ({
        useAIGeneration: !prevState.useAIGeneration,
        showAIConfig: !prevState.useAIGeneration
      }), () => {
        // If switching TO AI generation mode, sync with manual sections
        if (this.state.useAIGeneration) {
          this.syncAIConfigWithManualSections();
        }
      });
    }

      updateAIConfig = async (field, value) => {
    // Difficulty must remain editable in builder; do not persist or lock it here
    // Previously this saved to DB and locked difficulty across sessions
    this.setState(prevState => ({
      aiTestConfig: {
        ...prevState.aiTestConfig,
        [field]: value
      },
      // Ensure any inadvertent locks are cleared in builder context
      difficultyLocked: false
    }));
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    // Clear AI Test active flag
    try { localStorage.removeItem('AI_TEST_ACTIVE'); } catch (_) {}
  // Remove navigation guards
  this.removeNavigationGuards();
  }

  handleBeforeUnload = (e) => {
    // Only warn if user is actively building a test (Qnumber > 0 or has unsaved sections/questions)
    const isBuilding = (this.state.Qnumber && this.state.Qnumber > 0) ||
      (Array.isArray(this.state.sections) && this.state.sections.some(sec => (sec.questions || []).length > 0));
    if (!isBuilding) return;

    const message = 'Are you sure you want to close the tab? You will loose all your work.';
    e.preventDefault();
    e.returnValue = message; // Required for Chrome
    return message; // For older browsers
  }

  // Determine whether builder is active and should lock navigation
  isBuilderActive = () => {
    return this.state.lockActive && !this.state.exitAllowed;
  }

  // Allow exiting (used by Publish/Close flows only)
  allowExit = () => {
    this.setState({ exitAllowed: true, lockActive: false });
  }

  // Navigation guard installers
  installNavigationGuards = () => {
    try {
      // Block React Router transitions
      if (this.props.history && typeof this.props.history.block === 'function') {
        this.unblockHistory = this.props.history.block((tx) => {
          if (this.isBuilderActive()) {
            this.props.showToast && this.props.showToast({ type: 'warning', message: 'Finish setup or use the Close button to exit.', pos: 'bottom' });
            return 'You have an unfinished test. Please finish or click Close to exit.';
          }
          return undefined;
        });
      }
      // Prevent back/forward browser navigation
      window.addEventListener('popstate', this.handlePopState, true);
      // Guard hash changes too
      window.addEventListener('hashchange', this.handleHashChange, true);
      // Block ESC key from closing dialogs
      window.addEventListener('keydown', this.blockEscapeKey, true);
    } catch (_) {}
  }

  removeNavigationGuards = () => {
    try {
      if (this.unblockHistory) { this.unblockHistory(); this.unblockHistory = null; }
      window.removeEventListener('popstate', this.handlePopState, true);
      window.removeEventListener('hashchange', this.handleHashChange, true);
      window.removeEventListener('keydown', this.blockEscapeKey, true);
    } catch (_) {}
  }

  handlePopState = (e) => {
    if (this.isBuilderActive()) {
      e.preventDefault();
      // Attempt to negate the navigation
      if (this.props.history && typeof this.props.history.go === 'function') {
        this.props.history.go(1);
      }
      this.props.showToast && this.props.showToast({ type: 'warning', message: 'Finish setup or use the Close button to exit.', pos: 'bottom' });
    }
  }

  handleHashChange = (e) => {
    if (this.isBuilderActive()) {
      e.preventDefault();
      // Revert the hash change
      if (this.props.history && typeof this.props.history.go === 'function') {
        this.props.history.go(1);
      }
      this.props.showToast && this.props.showToast({ type: 'warning', message: 'Finish setup or use the Close button to exit.', pos: 'bottom' });
    }
  }

  blockEscapeKey = (e) => {
    if (e.key === 'Escape' && this.isBuilderActive()) {
      e.preventDefault();
      e.stopPropagation();
      this.props.showToast && this.props.showToast({ type: 'info', message: 'Use the Close button to exit the Test Builder.', pos: 'bottom' });
    }
  }

  // Disabled in builder: do not check or enforce any existing difficulty locks
  checkExistingTestAttempt = async () => {
    
    this.setState({ difficultyLocked: false });
  }

  // Disabled in builder: do not persist or lock difficulty selection
  saveDifficultySelection = async (_difficulty) => {
    
    return;
  }

  // Clear difficulty lock when test is completed/published
  clearDifficultyLock = async () => {
    try {
      if (!this.props.thoughtID || !this.props.userdata?.uid) {
        return;
      }


      // Update the test attempt status to completed
      if (this.state.existingTestAttempt) {
        await this.props.updateTestAttempt({
          ...this.state.existingTestAttempt,
          status: 'completed'
        });
      }

      // Reset local state
      this.setState({
        difficultyLocked: false,
        existingTestAttempt: null,
        aiTestConfig: {
          ...this.state.aiTestConfig,
          difficulty: 'basic' // Reset to default
        }
      });

      

    } catch (error) {
      
    }
  }

  // Regenerate a specific question in AI preview (class-scoped)
  regeneratePreviewQuestion = async (sectionIndex, qIndex) => {
    try {
      if (!this.state.aiGeneratedTest) return;
      const key = `${sectionIndex}-${qIndex}`;
      this.setState({ regeneratingQuestion: key });
      // Inform the user that generation may take some time
      this.props.showToast && this.props.showToast({
        type: 'info',
        message: 'Generating a new question. This may take up to a minute. Please wait…',
        pos: 'bottom'
      });

      // Build existing question stems to avoid
      const allExisting = [];
      this.state.aiGeneratedTest.sections.forEach(sec => {
        (sec.questions || []).forEach(q => allExisting.push(q.question));
      });

      const current = this.state.aiGeneratedTest.sections[sectionIndex].questions[qIndex];

      // Lead content mirrors what was used for generation
      const contentToUse = (this.state.hasAttachments && (this.state.transcript || '').trim())
        ? (this.state.transcript || '').trim()
        : (this.state.thoughtData?.quote || this.state.thoughtData?.content || '');

      const leadContent = {
        title: (this.state.hasAttachments && (this.state.transcript || '').trim()) ? '' : (this.props.title || ''),
        content: contentToUse,
        category: this.state.leadContext?.category || 'General Leadership',
        thoughtType: this.state.leadContext?.thoughtType || 'leadership',
        transcript: (this.state.hasAttachments && (this.state.transcript || '').trim()) ? (this.state.transcript || '').trim() : undefined
      };

      const newQuestion = await regenerateSingleQuestion(
        leadContent,
        { difficulty: this.state.aiTestConfig?.difficulty || 'basic' },
        allExisting,
        current?.question || ''
      );

      // Replace only the one question
      const aiGeneratedTest = { ...this.state.aiGeneratedTest };
      const updatedSection = { ...aiGeneratedTest.sections[sectionIndex] };
      const updatedQuestions = [...updatedSection.questions];
      updatedQuestions[qIndex] = {
        question: newQuestion.question,
        options: newQuestion.options,
        correctAnswer: newQuestion.correctAnswer
      };
      updatedSection.questions = updatedQuestions;
      aiGeneratedTest.sections = [
        ...aiGeneratedTest.sections.slice(0, sectionIndex),
        updatedSection,
        ...aiGeneratedTest.sections.slice(sectionIndex + 1)
      ];

      // Keep metadata totalQuestions unchanged
      this.setState({ aiGeneratedTest, regeneratingQuestion: null });
      this.props.showToast && this.props.showToast({ type: 'success', message: 'Question regenerated', pos: 'bottom' });
    } catch (error) {
      this.setState({ regeneratingQuestion: null });
      this.props.showToast && this.props.showToast({ type: 'error', message: error.message || 'Failed to regenerate question', pos: 'bottom' });
    }
  }

    // Sync AI config with manual section setup when available
    syncAIConfigWithManualSections = () => {
      const { sections } = this.state;
      if (sections && sections.length > 0) {
        // Calculate average questions per section from manual setup
        const totalQuestions = sections.reduce((sum, section) => sum + section.questions.length, 0);
        const avgQuestionsPerSection = totalQuestions > 0 
          ? Math.round(totalQuestions / sections.length) 
          : 1;

        // Only sync if user hasn't modified AI config yet (still at defaults)
        const isDefaultConfig = this.state.aiTestConfig.numberOfSections === 2 && 
                               this.state.aiTestConfig.questionsPerSection === 5;

        if (isDefaultConfig || totalQuestions > 0) {
          this.setState(prevState => ({
            aiTestConfig: {
              ...prevState.aiTestConfig,
              numberOfSections: Math.min(sections.length, 3), // Cap at 3 sections
              questionsPerSection: Math.min(Math.max(avgQuestionsPerSection, 1), 5) // Cap between 1-5
            }
          }));

          // Show a toast to inform the user
          this.props.showToast({
            type: 'info',
            message: `AI config synced with your manual setup: ${sections.length} sections, ${avgQuestionsPerSection} questions each`,
            pos: 'bottom'
          });
        }
      }
    }

    generateAITest = async () => {
      if (!this.state.leadContext || !this.state.thoughtData) {
        this.props.showToast({
          type: 'error',
          message: 'Lead content is required for AI test generation. Please ensure your post content is available.',
          pos: 'bottom'
        });
        return;
      }

      // Check if transcript is required but not provided
      if (this.state.hasAttachments && (!this.state.transcript || this.state.transcript.trim() === '')) {
        this.props.showToast({
          type: 'error',
          message: 'Transcript is required for leads with attachments. Please provide a transcript before generating the test.',
          pos: 'bottom'
        });
        return;
      }

      // NEW: If attachments are present and transcript provided, check duplicates before generation
      if (this.state.hasAttachments && (this.state.transcript || '').trim().length > 0) {
        try {
          const { isDuplicate } = await checkTranscriptDuplicate((this.state.transcript || '').trim());
          if (isDuplicate) {
            alert('❌ Duplicate transcript detected. You cannot proceed with a duplicate transcript.');
            return; // block generation
          }
        } catch (_e) {
          // On unexpected error, allow flow but warn user
          this.props.showToast({ type: 'warning', message: 'Could not verify transcript uniqueness. Proceeding.', pos: 'bottom' });
        }
      }

      this.setState({ generatingTest: true });

      try {
        const { aiTestConfig, leadContext, thoughtData } = this.state;
        
        // Prepare the lead content for AI generation
        // Use transcript if available and there are attachments, otherwise use regular content
        const contentToUse = (this.state.hasAttachments && this.state.transcript.trim()) 
          ? this.state.transcript.trim()
          : (thoughtData.quote || thoughtData.content || '');
        
        const leadContent = {
          title: (this.state.hasAttachments && this.state.transcript.trim()) ? '' : (this.props.title || ''),
          content: contentToUse,
          category: leadContext.category || 'General Leadership',
          thoughtType: leadContext.thoughtType || 'leadership',
          isTranscript: this.state.hasAttachments && this.state.transcript.trim()
        };

        // Derive requested configuration
        const requestedSections = aiTestConfig.numberOfSections;
        const requestedPerSection = aiTestConfig.questionsPerSection;
        const requestedTotal = requestedSections * requestedPerSection;

        // Enforce content-length-based limits prior to generation: if violated, block and show popup
        const contentForLimits = this.getLeadTextForQuestionLimit();
        const lengthClass = this.getContentLengthClass(contentForLimits);
        const wordCount = this.countWords(contentForLimits);

        if ((lengthClass === 'short' && requestedTotal > 5) || (lengthClass === 'long' && requestedTotal < 10)) {
          this.showQuestionRuleViolation({ lengthClass, requestedTotal, wordCount });
          return; // Do not proceed with generation
        }

        const testConfig = {
          numberOfSections: requestedSections,
          questionsPerSection: requestedPerSection,
          difficulty: aiTestConfig.difficulty,
          totalQuestions: requestedTotal
        };



        // Call the AI test generator
        const aiTestData = await generateAITest(leadContent, testConfig);



        // Process and integrate the AI-generated test
        this.integrateAIGeneratedTest(aiTestData);

        // Check if AI generated fewer questions than requested and show appropriate message
        if (aiTestData.metadata.hasFewerQuestions) {
          
          // Show toast notification
          this.props.showToast({
            type: 'warning',
            message: `⚠️ AI could only generate ${aiTestData.metadata.totalQuestions} questions out of ${aiTestData.metadata.requestedQuestions} requested. The test has been created with the available questions.`,
            pos: 'bottom'
          });
          
          // Failsafe: Also show browser alert as backup
          alert(`⚠️ Notice: AI could only generate ${aiTestData.metadata.totalQuestions} questions out of ${aiTestData.metadata.requestedQuestions} requested. The test has been created with the available questions.`);
        } else {
          this.props.showToast({
            type: 'success',
            message: `AI generated ${aiTestData.sections.length} sections with ${aiTestData.metadata.totalQuestions} questions!`,
            pos: 'bottom'
          });
        }

              } catch (error) {
          this.props.showToast({
            type: 'error',
            message: error.message || 'AI is currently busy. Please use manual quiz creation instead.',
            pos: 'bottom'
          });
        } finally {
          this.setState({ generatingTest: false });
        }
    }

    integrateAIGeneratedTest = (aiTestData) => {
      // Store AI test data for preview instead of immediately integrating
      this.setState({
        aiGeneratedTest: aiTestData,
        showAIPreview: true,
        previewMode: true,
        generatingTest: false,
        showAIConfig: false
      });


    }

    // Accept AI generated test and publish it directly
    acceptAITest = () => {
      const { aiGeneratedTest, aiTestConfig } = this.state;
      
      if (!aiGeneratedTest) return;

      // Generate a title if not provided
      const testTitle = aiTestConfig.customTopic && aiTestConfig.customTopic.trim() !== '' 
        ? `${aiTestConfig.customTopic} Test`
        : `${aiTestConfig.category} Assessment`;

      // Convert AI response to internal sections format, filtering out any invalid questions defensively
      const sections = aiGeneratedTest.sections.map((section, index) => ({
        id: index + 1,
        name: section.name || `Section ${index + 1}`,
        questions: (section.questions || [])
          .filter((q) => {
            const opts = Array.isArray(q?.options) ? q.options : [];
            if (opts.length !== 4) return false;
            const trimmed = opts.map(o => (o || '').trim());
            if (trimmed.some(o => !o)) return false;
            const uniq = new Set(trimmed.map(o => o.toLowerCase()));
            if (uniq.size !== 4) return false;
            const correct = (q?.correctAnswer || '').trim();
            return correct && trimmed.includes(correct);
          })
          .map((q) => ({
            question: q.question,
            a1: q.options[0] || '',
            a2: q.options[1] || '',
            a3: q.options[2] || '',
            a4: q.options[3] || '',
            a5: q.correctAnswer || q.options[0]
          }))
      }));

      // Update state with AI-generated content and publish immediately
      this.setState({
        sections: sections,
        stitle: testTitle,
        showAIPreview: false,
        aiGeneratedTest: null,
        previewMode: false,
        useAIGeneration: true,//false,
        showAIConfig: true,//false
      }, () => {
        // After state is updated, publish the test directly
        this.publishAITest();
      });


    }

    // Publish the AI-generated test directly
    publishAITest = async () => {
      // Calculate total questions across all sections
      const totalQuestions = this.state.sections.reduce((sum, section) => sum + section.questions.length, 0);
      
      // Enforce content-length-based limits
      const contentForLimits = this.getLeadTextForQuestionLimit();
      const lengthClass = this.getContentLengthClass(contentForLimits);
      if (lengthClass === 'long' && totalQuestions < 10) {
        this.showQuestionRuleViolation({ lengthClass, requestedTotal: totalQuestions, wordCount: this.countWords(contentForLimits) });
        return;
      }
      if (lengthClass === 'short' && totalQuestions > 5) {
        this.showQuestionRuleViolation({ lengthClass, requestedTotal: totalQuestions, wordCount: this.countWords(contentForLimits) });
        return;
      }
      
      // Validate minimum questions based on test difficulty
      const testDifficulty = this.state.aiTestConfig?.difficulty || 'basic';
      const validation = validateMinimumQuestions(totalQuestions, testDifficulty);
      
      if (!validation.isValid) {
        const difficultyInfo = getDifficultyInfo(testDifficulty);
        alert(
          `❌ AI Test Publishing Failed\n\n` +
          `${validation.message}\n\n` +
          `📊 Generated test: ${totalQuestions} question${totalQuestions === 1 ? '' : 's'}\n` +
          `🎯 ${difficultyInfo.displayName} difficulty requires: ${validation.minRequired} question${validation.minRequired === 1 ? '' : 's'}\n\n` +
          `Please regenerate the test with more questions or select a lower difficulty.`
        );
        return;
      }
      
      // Calculate final LC reward
      const finalLCReward = this.calculateLCReward();
      
      // Convert sections to the old format for backward compatibility
      let questionsData = {};
      let questionIndex = 1;
      
      this.state.sections.forEach(section => {
        section.questions.forEach(question => {
          questionsData[`QandA${questionIndex}`] = {
            question: question.question || '',
            a1: question.a1 || '',
            a2: question.a2 || '',
            a3: question.a3 || '',
            a4: question.a4 || '',
            a5: question.a5 || '',
            sectionId: section.id || 'default',
            sectionName: section.name || 'Section'
          };
          questionIndex++;
        });
      });

      // Clean sections data
      const cleanSections = this.state.sections.map(section => ({
        id: section.id || 'default',
        name: section.name || 'Section',
        questions: section.questions.map(q => ({
          question: q.question || '',
          a1: q.a1 || '',
          a2: q.a2 || '',
          a3: q.a3 || '',
          a4: q.a4 || '',
          a5: q.a5 || ''
        }))
      }));

      // Create the test body for publishing
      var body = {
        thoughtID: this.props.thoughtID,
        type: SURVEY_LIST,
        title: this.state.stitle,
        companyID: this.state.companyid,
        typeofSurvey: this.state.typeofsurvey,
        size: totalQuestions,
        sections: cleanSections,
        testComplexity: this.state.aiTestConfig?.difficulty || 'medium',
        categoryType: this.state.aiTestConfig?.category || 'leadership',
        estimatedLCReward: finalLCReward,
        aiGenerated: true, // Flag to indicate this was AI-generated
        // Identify the source of the test to preserve/delete correctly on post edits
        testSource: (this.state.hasAttachments && (this.state.transcript || '').trim()) ? 'transcript' : 'content',
        sourceMeta: {
          hasAttachments: !!this.state.hasAttachments,
          usedTranscript: !!((this.state.transcript || '').trim()),
        },
        ...questionsData,
        ownMaterial: this.state.ownMaterial,
        dailyThoughtType: this.props.dailyThoughtType,
        groupid: this.props.groupid
      };


      
      // Actually publish the test
      // If transcript was used, persist its excerpt before creating survey
      const usingTranscript = this.state.hasAttachments && (this.state.transcript || '').trim();
      const doCreate = () => this.props.createSurvey(body);
      if (usingTranscript) {
        try {
          const transcriptText = (this.state.transcript || '').trim();
          const meta = { surveyid: this.props.thoughtID, companyID: this.state.companyid, source: 'ai' };
          const { key, excerpt, isDuplicate } = await checkTranscriptDuplicate(transcriptText);
          if (isDuplicate) {
            alert('❌ Duplicate transcript detected. You cannot proceed with a duplicate transcript.');
            return;
          }
          await saveTranscriptExcerpt(key, excerpt, meta);
        } catch (_e) {
          this.props.showToast({ type: 'warning', message: 'Could not persist transcript excerpt. Proceeding.', pos: 'bottom' });
        }
      }
      doCreate();

      // Allow exit after successful publish
      this.allowExit();

      // Reset form state
      this.setState({
        stitle: "", 
        typeofsurvey: 0, 
        Qnumber: 1000,
        sections: [{ id: 1, name: 'Section 1', questions: [] }],
        currentSection: 0
      });

      // Calculate and award points
      const pointsToAdd = Math.round(finalLCReward * 100);
      
      var params = {
        uid: this.props.userdata.uid,
        userID: this.props.userdata.userID,
        pointsCurrent: this.props.userdata.points,
        pointsAdded: pointsToAdd,
        ypointsCurrent: this.props.userdata.pointsy,
        trailID: this.makeid(10),
        companyName: this.props.userdata.companyName,
        firstName: this.props.userdata.firstName,
        lastName: this.props.userdata.lastName,
        title: this.state.stitle || 'AI Generated Test',
        actionType: `AI Test Published (${finalLCReward.toFixed(2)} LC earned)`,
        actionDesc: `${this.state.stitle} - ${cleanSections.length} sections, ${totalQuestions} questions`,
        forceAward: true
      };

      if (this.props.userdata.execmember === true) {
        this.props.addMorePoints(params);
      }

      // Show success message
      this.props.showToast({
        type: 'success',
        message: `🎉 AI test "${this.state.stitle}" has been published successfully! You earned ${finalLCReward.toFixed(2)} LC.`,
        pos: 'bottom'
      });

      // Clear difficulty lock since test is now published and completed
      this.clearDifficultyLock();

      // Update survey stage and reset
      this.props.getSurveyStage(this.props.thoughtID);
      this.props.resetMakeTest(this.props.thoughtID, this.props.companyID, this.props.companyID);

      // Show lead if available
      if (this.props.showLeadb) {
        this.props.showLeadb(this.props, 'AI test published');
             }
     }

     // Accept AI test for manual editing (don't publish immediately)
     acceptAITestForEditing = () => {
       const { aiGeneratedTest, aiTestConfig } = this.state;
       
       if (!aiGeneratedTest) return;

       // Generate a title if not provided
       const testTitle = aiTestConfig.customTopic && aiTestConfig.customTopic.trim() !== '' 
         ? `${aiTestConfig.customTopic} Test`
         : `${aiTestConfig.category} Assessment`;

       // Convert AI response to internal sections format, filtering invalid questions defensively
       const sections = aiGeneratedTest.sections.map((section, index) => ({
         id: index + 1,
         name: section.name || `Section ${index + 1}`,
         questions: (section.questions || [])
           .filter((q) => {
             const opts = Array.isArray(q?.options) ? q.options : [];
             if (opts.length !== 4) return false;
             const trimmed = opts.map(o => (o || '').trim());
             if (trimmed.some(o => !o)) return false;
             const uniq = new Set(trimmed.map(o => o.toLowerCase()));
             if (uniq.size !== 4) return false;
             const correct = (q?.correctAnswer || '').trim();
             return correct && trimmed.includes(correct);
           })
           .map((q) => ({
             question: q.question,
             a1: q.options[0] || '',
             a2: q.options[1] || '',
             a3: q.options[2] || '',
             a4: q.options[3] || '',
             a5: q.correctAnswer || q.options[0]
           }))
       }));

       // Update state with AI-generated content for manual editing
       this.setState({
         sections: sections,
         stitle: testTitle,
         currentSection: 0,
         showAIPreview: false,
         aiGeneratedTest: null,
         previewMode: false,
         useAIGeneration: true,//false,
         showAIConfig: true,//false,
         Qnumber: 0 // Keep in setup mode to allow review/editing
       });

       this.props.showToast({
         type: 'success',
         message: 'AI test accepted! You can now review and edit questions before publishing.',
         pos: 'bottom'
       });


     }

     // Reject AI test and return to configuration
    rejectAITest = () => {
      this.setState({
        showAIPreview: false,
        aiGeneratedTest: null,
        previewMode: false,
        showAIConfig: true,
        useAIGeneration: true // Keep AI mode active
      });

      this.props.showToast({
        type: 'info',
        message: 'Modify your AI configuration and generate a new test.',
        pos: 'bottom'
      });
    }

    // Regenerate AI test with same or updated configuration
    regenerateAITest = async () => {
      this.setState({
        showAIPreview: false,
        aiGeneratedTest: null
      });
      
      // Use the existing generateAITest method
      await this.generateAITest();
    }

    // Close AI preview and return to manual mode
    cancelAIPreview = () => {
      this.setState({
        showAIPreview: false,
        aiGeneratedTest: null,
        previewMode: false,
        useAIGeneration: true,//false,
        showAIConfig: true,//false
      });
    }

    // DISABLED: Mock AI generation functions removed (user requested no mock/dummy tests)
    // All mock test generation functionality has been removed to prevent accidental test creation

    render() {
      const { handleClosex = () => {}, testHistory } = this.props
  
      const longText = `Please enter the CORRECT ANSWER to your set question. This answer must correspond to just ONE of
      your supplied answers in the above 4 options.`;
      
      const currentSection = this.state.sections[this.state.currentSection];
      const totalQuestions = this.state.sections.reduce((sum, section) => sum + section.questions.length, 0);
      const estimatedReward = this.calculateLCReward();

    return (
      // <div className="bod">
      <div style={{
        marginLeft: isMobile ? '5px' : '30px',
        marginRight: isMobile ? '5px' : '0px',
        marginTop: '15px',
        minHeight: '600px',
        maxHeight: '90vh',
        overflowY: 'auto',
        top: '-15px',
        width: isMobile ? '98%' : '90%',
        maxWidth: isMobile ? '98%' : '90%',
        paddingBottom: '60px'
       }}>
        <Prompt when={this.isBuilderActive()} message="You have an unfinished test. Please finish or click Close to exit." />
         
        <div style={{ 
          padding: isMobile ? '0 2px' : '0 15px',
          maxWidth: '100%',
          width: '100%'
        }}>
        { this.state.Qnumber===0 && !this.state.showAIPreview ?
        <React.Fragment>
        <div style={{
          textAlign: 'center',
          marginBottom: '30px'
        }}>
          <h4 style={{ 
            color: '#2c3e50',
            marginBottom: '10px',
            fontWeight: '600'
          }}>
            📝 Test Builder
          </h4>
          
          {/* Lead Category Display */}
          {this.state.leadContext && (
            <div style={{
              margin: '10px auto 15px',
              padding: '8px 16px',
              background: this.state.leadContext.category !== 'Not specified' ? '#e3f2fd' : '#fff3e0',
              border: `1px solid ${this.state.leadContext.category !== 'Not specified' ? '#bbdefb' : '#ffcc02'}`,
              borderRadius: '15px',
              display: 'inline-block',
              fontSize: '14px',
              color: this.state.leadContext.category !== 'Not specified' ? '#1565c0' : '#f57f17',
              fontWeight: '500'
            }}>
              📚 <strong>Lead Category:</strong> {this.state.leadContext.category}
              {this.state.fetchingThought && (
                <span style={{ marginLeft: '8px', fontSize: '12px', opacity: 0.7 }}>
                  (fetching...)
                </span>
              )}
            </div>
          )}
          
          {/* AI Test Generation Toggle */}
          <div style={{
            margin: '15px auto',
            maxWidth: isMobile ? '99%' : '600px',
            padding: isMobile ? '10px' : '20px',
            background: '#f8f9fc',
            borderRadius: '12px',
            border: '1px solid #e1e5e9'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: isMobile ? '8px' : '15px',
              marginBottom: '15px',
              flexWrap: isMobile ? 'wrap' : 'nowrap'
            }}>
              <span style={{ 
                fontSize: isMobile ? '14px' : '16px',
                fontWeight: '600',
                color: this.state.useAIGeneration ? '#6c757d' : '#007bff',
                transition: 'color 0.3s ease',
                textAlign: 'center'
              }}>
                ✋ Manual Creation
              </span>
              
              {/* Slide Button Container */}
              <div 
                //onClick={this.toggleAIGeneration}
                style={{
                  position: 'relative',
                  width: isMobile ? '70px' : '80px',
                  height: isMobile ? '35px' : '40px',
                  backgroundColor: this.state.useAIGeneration ? '#007bff' : '#d3d3d3',
                  borderRadius: '25px',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s ease',
                  boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)',
                  border: '2px solid #fff',
                  flexShrink: 0
                }}
              >
                {/* Sliding Circle */}
                <div style={{
                  position: 'absolute',
                  top: '3px',
                  left: this.state.useAIGeneration ? (isMobile ? '37px' : '43px') : '3px',
                  width: isMobile ? '27px' : '32px',
                  height: isMobile ? '27px' : '32px',
                  backgroundColor: '#ffffff',
                  borderRadius: '50%',
                  transition: 'left 0.3s ease',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: isMobile ? '14px' : '16px'
                }}>
                  {this.state.useAIGeneration ? '🤖' : '✋'}
                </div>
              </div>
              
              <span style={{ 
                fontSize: isMobile ? '14px' : '16px',
                fontWeight: '600',
                color: this.state.useAIGeneration ? '#007bff' : '#6c757d',
                transition: 'color 0.3s ease',
                textAlign: 'center'
              }}>
                🤖 AI Generation
              </span>
            </div>
            
           <p style={{ 
              textAlign: 'center',
              margin: '0',
              fontSize: isMobile ? '13px' : '14px',
              color: '#6c757d',
              lineHeight: '1.4',
              padding: isMobile ? '0 5px' : '0'
            }}>
              {this.state.useAIGeneration 
                ? "Let AI create a comprehensive test based on your lead content and category"
                : "Create your test manually with full control over each question"
              }
            </p>
          </div>

          {/* AI Configuration Panel */}
          {this.state.showAIConfig && (
            <div style={{
              maxWidth: isMobile ? '99%' : '600px',
              margin: isMobile ? '0 auto 15px auto' : '0 auto 20px auto',
              background: '#fff',
              borderRadius: '12px',
              padding: isMobile ? '10px' : '24px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              border: '2px solid #007bff'
            }}>
              <h5 style={{
                color: '#007bff',
                marginBottom: isMobile ? '15px' : '20px',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: isMobile ? '16px' : '18px',
                flexWrap: 'wrap'
              }}>
                🤖 AI Test Configuration
                {this.state.aiGeneratedTest && (
                  <span style={{
                    fontSize: isMobile ? '11px' : '12px',
                    background: '#ffc107',
                    color: '#212529',
                    padding: '4px 8px',
                    borderRadius: '12px',
                    fontWeight: '500'
                  }}>
                    Modifying after preview
                  </span>
                )}
              </h5>
              
              {/* Configuration sync notice */}
              {this.state.sections.length > 0 && (
                <div style={{
                  background: '#e3f2fd',
                  border: '1px solid #bbdefb',
                  borderRadius: '8px',
                  padding: '12px',
                  marginBottom: '16px',
                  fontSize: '14px',
                  color: '#1565c0'
                }}>
                  💡 <strong>Smart Sync:</strong> AI configuration has been automatically adjusted to match your manual section setup ({this.state.sections.length} sections). You can modify these settings below if needed.
                </div>
              )}
              
              <div style={{ display: 'grid', gap: '16px' }}>
                {/* Number of Sections */}
                <div>
                  <label style={{ 
                    display: 'block', 
                    marginBottom: '8px',
                    fontWeight: '500',
                    color: '#495057'
                  }}>
                    Number of Sections:
                  </label>
                  <select
                    value={this.state.aiTestConfig.numberOfSections}
                    onChange={(e) => this.updateAIConfig('numberOfSections', parseInt(e.target.value))}
                    style={{
                      width: '100%',
                      padding: '10px',
                      borderRadius: '6px',
                      border: '1px solid #ced4da',
                      fontSize: '14px'
                    }}
                  >
                    {[1, 2, 3].map(num => (
                      <option key={num} value={num}>{num} section{num > 1 ? 's' : ''}</option>
                    ))}
                  </select>
                </div>

                {/* Questions per Section */}
                <div>
                  <label style={{ 
                    display: 'block', 
                    marginBottom: '8px',
                    fontWeight: '500',
                    color: '#495057'
                  }}>
                    Questions per Section:
                  </label>
                  <select
                    value={this.state.aiTestConfig.questionsPerSection}
                    onChange={(e) => this.updateAIConfig('questionsPerSection', parseInt(e.target.value))}
                    style={{
                      width: '100%',
                      padding: '10px',
                      borderRadius: '6px',
                      border: '1px solid #ced4da',
                      fontSize: '14px'
                    }}
                  >
                    {Array.from({ length: 5 }, (_, i) => i + 1).map(num => (
                      <option key={num} value={num}>{num} question{num > 1 ? 's' : ''}</option>
                    ))}
                  </select>
                </div>

                {/* Difficulty Level */}
                <div>
                  <label style={{ 
                    display: 'block', 
                    marginBottom: '8px',
                    fontWeight: '500',
                    color: '#495057'
                  }}>
                    Difficulty Level:
                    {/* Difficulty should never be locked in builder */}
                  </label>
                  <select
                    value={this.state.aiTestConfig.difficulty}
                    onChange={(e) => this.updateAIConfig('difficulty', e.target.value)}
                    disabled={false}
                    style={{
                      width: '100%',
                      padding: '10px',
                      borderRadius: '6px',
                      border: '1px solid #ced4da',
                      fontSize: '14px',
                      backgroundColor: '#fff',
                      color: '#495057',
                      cursor: 'pointer'
                    }}
                  >
                    <option value="basic">Basic - Fundamental concepts (Default)</option>
                    <option value="medium">Medium - Intermediate understanding</option>
                    <option value="hard">Hard - Advanced application</option>
                  </select>
                  {/* No locking message in builder */}
                </div>

                {/* Transcript Field - Only show when there are video/podcast attachments */}
                {this.state.hasAttachments && (
                  <div>
                    <label style={{ 
                      display: 'block', 
                      marginBottom: '8px',
                      fontWeight: '500',
                      color: '#495057'
                    }}>
                      📝 Content Transcript <span style={{ color: '#dc3545' }}>*</span>
                    </label>
                    <div style={{
                      marginBottom: '8px',
                      padding: '8px 12px',
                      background: '#fff3cd',
                      border: '1px solid #ffeaa7',
                      borderRadius: '6px',
                      fontSize: '13px',
                      color: '#856404'
                    }}>
                      💡 <strong>Required:</strong> Since your lead contains attachments, please provide a text transcript of the content. The AI will use this transcript instead of the attached files to create relevant questions.
                    </div>
                    <textarea
                      value={this.state.transcript}
                      onChange={this.handleTranscriptChange}
                      placeholder="Enter the transcript or text content from your attachment here. This will be used by the AI to generate relevant test questions..."
                      style={{
                        width: '100%',
                        minHeight: '120px',
                        padding: '12px',
                        borderRadius: '6px',
                        border: '1px solid #ced4da',
                        fontSize: '14px',
                        fontFamily: 'inherit',
                        resize: 'vertical',
                        background: this.state.transcriptLocked ? '#f8f9fc' : '#fff'
                      }}
                      readOnly={this.state.transcriptLocked}
                    />
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginTop: '8px' }}>
                      <button
                        onClick={async () => { const ok = await this.validateTranscript(); if (ok) { /* locked in validate */ } }}
                        disabled={this.state.transcriptValidating || !this.state.transcript || this.state.transcript.trim() === ''}
                        style={{
                          background: this.state.transcriptValidated ? '#28a745' : '#17a2b8',
                          color: '#fff',
                          border: 'none',
                          padding: '8px 12px',
                          borderRadius: '6px',
                          fontSize: '13px',
                          cursor: (this.state.transcriptValidating || !this.state.transcript || this.state.transcript.trim() === '') ? 'not-allowed' : 'pointer',
                          fontWeight: 600
                        }}
                      >
                        {this.state.transcriptValidating ? 'Validating…' : (this.state.transcriptValidated ? '✓ Validated' : '✔ Validate Transcript')}
                      </button>
                      {this.state.transcriptLocked ? (
                        <button
                          onClick={() => this.setState({ transcriptLocked: false, transcriptValidated: false, transcriptValidationMessage: '', transcriptSimilarityScore: null })}
                          style={{
                            background: '#ffc107',
                            color: '#212529',
                            border: 'none',
                            padding: '8px 12px',
                            borderRadius: '6px',
                            fontSize: '13px',
                            cursor: 'pointer',
                            fontWeight: 600
                          }}
                          title="Unlock to edit transcript. You will need to validate again."
                        >
                          ✏️ Edit Transcript
                        </button>
                      ) : null}
                      {this.state.transcriptValidated && (
                        <span style={{ fontSize: '12px', color: '#28a745' }}>
                          ✓ Ready for AI generation
                        </span>
                      )}
                    </div>
                    {this.state.transcriptValidationMessage && (
                      <div style={{
                        fontSize: '12px',
                        marginTop: '6px',
                        color: this.state.transcriptValidated ? '#28a745' : '#dc3545'
                      }}>
                        {this.state.transcriptValidationMessage}
                      </div>
                    )}
                    {this.state.transcript.length > 0 && (
                      <div style={{
                        fontSize: '12px',
                        color: '#6c757d',
                        marginTop: '4px'
                      }}>
                        {this.state.transcript.length} characters
                      </div>
                    )}
                  </div>
                )}

                {/* Summary */}
                <div style={{
                  background: '#e8f4fd',
                  padding: '12px',
                  borderRadius: '8px',
                  fontSize: '14px',
                  color: '#0c5460'
                }}>
                  <strong>Test Preview:</strong> {this.state.aiTestConfig.numberOfSections} sections • {this.state.aiTestConfig.questionsPerSection} questions each • Total: {this.state.aiTestConfig.numberOfSections * this.state.aiTestConfig.questionsPerSection} questions • Difficulty: {this.state.aiTestConfig.difficulty}
                </div>

                {/* Generate Button */}
                <button
                  onClick={async () => {
                    // If attachments exist and transcript not yet validated, run validation first
                    if (this.state.hasAttachments) {
                      if (!this.state.transcriptValidated) return; // force explicit validation first
                    }
                    // Proceed to generation
                    this.generateAITest();
                  }}
                  disabled={
                    this.state.generatingTest ||
                    (this.state.hasAttachments && (!this.state.transcript || this.state.transcript.trim() === '')) ||
                    this.state.transcriptValidating ||
                    (this.state.hasAttachments && !this.state.transcriptValidated)
                  }
                  style={{
                    padding: '12px 24px',
                    background: this.state.generatingTest ? '#6c757d' :
                              (this.state.hasAttachments && (!this.state.transcript || this.state.transcript.trim() === '')) ? '#dc3545' :
                              (this.state.hasAttachments && !this.state.transcriptValidated) ? '#17a2b8' : '#007bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '16px',
                    fontWeight: '600',
                    cursor: (
                      this.state.generatingTest ||
                      (this.state.hasAttachments && (!this.state.transcript || this.state.transcript.trim() === '')) ||
                      this.state.transcriptValidating ||
                      (this.state.hasAttachments && !this.state.transcriptValidated)
                    ) ? 'not-allowed' : 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px'
                  }}
                >
                  {this.state.generatingTest ? (
                    <>
                      <span style={{ 
                        width: '16px', 
                        height: '16px', 
                        border: '2px solid #fff',
                        borderTop: '2px solid transparent',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite'
                      }}></span>
                      Generating Test...
                    </>
                  ) : (this.state.hasAttachments && (!this.state.transcript || this.state.transcript.trim() === '')) ? (
                    <>
                      📝 Transcript Required
                    </>
                  ) : (this.state.hasAttachments && !this.state.transcriptValidated) ? (
                    <>
                      Validate Transcript First
                    </>
                  ) : (
                    <>
                      🤖 Generate AI Test
                    </>
                  )}
                </button>
                {/* Validation result helper text */}
                {this.state.hasAttachments && this.state.transcript && !this.state.transcriptLocked && (
                  <div style={{ marginTop: '8px', fontSize: '12px' }}>
                    {this.state.transcriptValidated ? (
                      <span style={{ color: '#28a745' }}>
                        ✓ Transcript validated{typeof this.state.transcriptSimilarityScore === 'number' ? ` • match ${(this.state.transcriptSimilarityScore * 100).toFixed(0)}%` : ''}
                      </span>
                    ) : this.state.transcriptValidating ? (
                      <span style={{ color: '#17a2b8' }}>Validating transcript…</span>
                    ) : this.state.transcriptValidationMessage ? (
                      <span style={{ color: '#dc3545' }}>✖ {this.state.transcriptValidationMessage}</span>
                    ) : null}
                  </div>
                )}
              </div>
            </div>
          )}
          
          <p style={{ 
            color: '#6c757d',
            fontSize: '16px',
            margin: '0 auto',
            maxWidth: '500px',
            lineHeight: '1.5'
          }}>
            Set up your test sections. You can create up to 5 sections with up to 15 questions each.
          </p>
          {totalQuestions > 0 && (
            <div style={{ 
              marginTop: '15px',
              padding: '10px 20px',
              background: '#e8f5e8',
              borderRadius: '20px',
              display: 'inline-block',
              fontSize: '14px',
              color: '#2d5a2d'
            }}>
              <strong>LC Reward: {estimatedReward.toFixed(2)} LC</strong> • {totalQuestions} questions • {this.state.sections.length} sections
            </div>
          )}
        </div>


        <p>
Set up a test related to your publication. You can create multiple sections with up to 15 questions each section. 
Each question has four possible answers of which only one will be the correct answer. 
The correct answer will be the fifth and last answer you fill in for every question.  
Once a test is published, you can't modify or change it. 
If you want to modify or change your test, you would have to re-publish your publication.
</p>
                  <Row>
          <Col sm={12}>
            <div>Is this Publication your own material?</div>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
                  <div className="radio-buttons">
                        Yes &nbsp;&nbsp;
                        <input
                          id="true"
                          value="true"
                          name="platform"
                          type="radio"
                          onChange={this.handleRadioChange}
                        />
                        &nbsp;&nbsp; No &nbsp;&nbsp;
                        <input
                          id="false"
                          value="false"
                          name="platform"
                          type="radio"
                          onChange={this.handleRadioChange}
                        />

                      </div>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <TextField
                 // autoFocus={true}
                  id="title"
                  label="Content"
                  multiline
                  fullWidth
                  margin="normal"
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{ maxLength: 200, readOnly: true }}
                  aria-describedby="surveyTitle"
                  // onChange={event => {
                  //   const { value } = event.target;
                  //   this.setState({stitle: swapStuff(value)})
                  // }}
                  //value={swapStuff(this.state.stitle)}
                  value={this.props.title}
                />
          </Col>
        </Row>

        <div style={{
          maxWidth: isMobile ? '99%' : '600px',
          margin: '0 auto 30px auto',
          background: '#fff',
          borderRadius: '12px',
          padding: isMobile ? '10px' : '24px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          border: '1px solid #e1e5e9'
        }}>
          <div style={{
            background: '#f8f9fc',
            borderRadius: '8px',
            padding: '20px',
            marginBottom: '20px'
          }}>
            <h5 style={{ 
              color: '#495057',
              marginBottom: '16px',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              📂 Test Sections ({this.state.sections.length}/5)
            </h5>
            
            <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap' }}>
              {this.state.sections.map((section, index) => (
                <div key={section.id} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <button
                    onClick={() => this.setState({ currentSection: index })}
                    style={{
                      padding: '10px 16px',
                      borderRadius: '20px',
                      border: 'none',
                      background: index === this.state.currentSection ? '#007bff' : '#e9ecef',
                      color: index === this.state.currentSection ? 'white' : '#495057',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '500',
                      transition: 'all 0.2s ease'
                    }}
                  >
                    {section.name} ({section.questions.length})
                  </button>
                  {this.state.sections.length > 1 && (
                    <button
                      onClick={() => this.removeSection(section.id)}
                      style={{
                        padding: '4px 8px',
                        borderRadius: '50%',
                        border: 'none',
                        background: '#dc3545',
                        color: 'white',
                        cursor: 'pointer',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        width: '24px',
                        height: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.2s ease'
                      }}
                      title={`Remove ${section.name}`}
                    >
                      ×
                    </button>
                  )}
                </div>
              ))}
            </div>
            
            {/* Add Section button */}
            <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap' }}>
              {this.state.sections.length < 5 && (
                <button
                  onClick={this.addSection}
                  style={{
                    padding: '10px 16px',
                    borderRadius: '20px',
                    border: '2px dashed #007bff',
                    background: 'transparent',
                    color: '#007bff',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500',
                    transition: 'all 0.2s ease'
                  }}
                >
                  ➕ Add Section
                </button>
              )}
            </div>
          </div>

          <div style={{
            background: '#fff',
            borderRadius: '8px',
            padding: '20px',
            border: '1px solid #e9ecef'
          }}>
            <h6 style={{ 
              color: '#495057',
              marginBottom: '12px',
              fontWeight: '600'
            }}>
              Editing Section {this.state.currentSection + 1}:
            </h6>
            
            <div style={{ display: 'flex', gap: '12px', alignItems: 'center', marginBottom: '16px' }}>
              <TextField
                value={currentSection?.name || ''}
                onChange={(e) => this.updateSectionName(currentSection.id, e.target.value)}
                placeholder="Section name"
                size="small"
                style={{ flex: 1 }}
                InputProps={{
                  style: {
                    borderRadius: '8px'
                  }
                }}
              />
            </div>
            
            <div style={{ 
              fontSize: '14px', 
              color: '#6c757d',
              background: '#f8f9fa',
              padding: '12px',
              borderRadius: '6px'
            }}>
              <strong>Questions:</strong> {currentSection?.questions.length || 0}/{this.state.maxQuestionsPerSection} • <strong>Total Questions:</strong> {totalQuestions}
            </div>
          </div>

          <div style={{ textAlign: 'center', marginTop: '24px' }}>
            <button
              onClick={() => this.setState({ Qnumber: 1 })}
              style={{
                background: '#28a745',
                color: 'white',
                border: 'none',
                padding: '12px 32px',
                borderRadius: '25px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                boxShadow: '0 2px 4px rgba(40, 167, 69, 0.3)',
                transition: 'all 0.2s ease'
              }}
            >
              🚀 START ADDING QUESTIONS
            </button>
          </div>
        </div>

        <Row>
          <Col sm={12}>
          </Col>
          </Row>
          </React.Fragment> 
          :
           this.state.Qnumber < 13 ?
          <React.Fragment> 
                    <h4><div style={{ width: isMobile ? '100%' : '600px', maxWidth: '100%' }}>📝 Test Builder - {currentSection?.name}</div></h4>
          
          {/* Content Validation Notification */}
          <div style={{
            background: this.state.hasAttachments ? '#e3f2fd' : '#f8f9fa',
            border: `1px solid ${this.state.hasAttachments ? '#2196f3' : '#dee2e6'}`,
            borderRadius: '8px',
            padding: '12px 16px',
            marginBottom: '16px',
            fontSize: '14px',
            color: this.state.hasAttachments ? '#1565c0' : '#495057'
          }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
              <span style={{ fontSize: '16px', lineHeight: '1' }}>
                {this.state.hasAttachments ? '📝' : '💡'}
              </span>
              <div>
                <strong>Content Validation:</strong> Please ensure all questions are related to the content of the lead
                {this.state.hasAttachments && (
                  <span>
                    {' '}or the provided transcript (since your lead contains attachments)
                  </span>
                )}
                . This helps maintain test quality and relevance for learners.
                {this.state.hasAttachments && this.state.transcript && (
                  <div style={{ 
                    marginTop: '8px', 
                    padding: '8px', 
                    background: 'rgba(33, 150, 243, 0.1)', 
                    borderRadius: '4px',
                    fontSize: '13px'
                  }}>
                    ✓ Transcript provided ({this.state.transcript.length} characters) - questions will be validated against this content.
                  </div>
                )}
              </div>
            </div>
          </div>
          
          {/* Transcript Field for Manual Test Creation - Only show when there are video/podcast attachments */}
          {this.state.hasAttachments && (
            <div style={{
              background: '#fff',
              borderRadius: '8px',
              padding: '16px',
              marginBottom: '16px',
              border: '1px solid #e9ecef'
            }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '8px',
                fontWeight: '500',
                color: '#495057'
              }}>
                📝 Content Transcript <span style={{ color: '#dc3545' }}>*</span>
              </label>
              <div style={{
                marginBottom: '8px',
                padding: '8px 12px',
                background: '#fff3cd',
                border: '1px solid #ffeaa7',
                borderRadius: '6px',
                fontSize: '13px',
                color: '#856404'
              }}>
                💡 <strong>Required:</strong> Since your lead contains attachments, please provide a text transcript of the content. This will be used for manual test validation to ensure questions are related to the content.
              </div>
              <textarea
                value={this.state.transcript}
                onChange={this.handleTranscriptChange}
                placeholder="Enter the transcript or text content from your attachment here. This will be used to validate that your manual test questions are related to the content..."
                style={{
                  width: '100%',
                  minHeight: '120px',
                  padding: '12px',
                  borderRadius: '6px',
                  border: '1px solid #ced4da',
                  fontSize: '14px',
                  fontFamily: 'inherit',
                  resize: 'vertical',
                  background: this.state.transcriptLocked ? '#f8f9fc' : '#fff'
                }}
                readOnly={this.state.transcriptLocked}
              />
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginTop: '8px' }}>
                <button
                  onClick={async () => { const ok = await this.validateTranscript(); if (ok) { /* state already updated */ } }}
                  disabled={this.state.transcriptValidating || !this.state.transcript || this.state.transcript.trim() === ''}
                  style={{
                    background: this.state.transcriptValidated ? '#28a745' : '#17a2b8',
                    color: '#fff',
                    border: 'none',
                    padding: '8px 12px',
                    borderRadius: '6px',
                    fontSize: '13px',
                    cursor: (this.state.transcriptValidating || !this.state.transcript || this.state.transcript.trim() === '') ? 'not-allowed' : 'pointer',
                    fontWeight: 600
                  }}
                >
                  {this.state.transcriptValidating ? 'Validating…' : (this.state.transcriptValidated ? '✓ Validated' : '✔ Validate Transcript')}
                </button>
                {this.state.transcriptLocked ? (
                  <button
                    onClick={() => this.setState({ transcriptLocked: false, transcriptValidated: false, transcriptValidationMessage: '', transcriptSimilarityScore: null })}
                    style={{
                      background: '#ffc107',
                      color: '#212529',
                      border: 'none',
                      padding: '8px 12px',
                      borderRadius: '6px',
                      fontSize: '13px',
                      cursor: 'pointer',
                      fontWeight: 600
                    }}
                    title="Unlock to edit transcript. You will need to validate again."
                  >
                    ✏️ Edit Transcript
                  </button>
                ) : null}
                {this.state.transcriptValidated && (
                  <span style={{ fontSize: '12px', color: '#28a745' }}>
                    ✓ Ready for manual publish
                  </span>
                )}
              </div>
              {/* Inline validation result for manual transcript */}
              {(this.state.transcriptValidating || this.state.transcriptValidationMessage) && (
                <div style={{ marginTop: '6px', fontSize: '12px' }}>
                  {this.state.transcriptValidating ? (
                    <span style={{ color: '#17a2b8' }}>Validating transcript…</span>
                  ) : (
                    <span style={{ color: this.state.transcriptValidated ? '#28a745' : '#dc3545' }}>
                      {this.state.transcriptValidationMessage}
                    </span>
                  )}
                </div>
              )}
              {this.state.transcript.length > 0 && (
                <div style={{
                  fontSize: '12px',
                  color: '#6c757d',
                  marginTop: '4px'
                }}>
                  {this.state.transcript.length} characters
                </div>
              )}
            </div>
          )}
          
          {/* Section Selection */}
          <div style={{ 
            background: '#f8f9fc', 
            padding: '12px', 
            borderRadius: '6px', 
            marginBottom: '15px',
            border: '1px solid #e9ecef',
            display: this.state.useAIGeneration ? 'none' : 'block'
          }}>
            <label style={{ 
              display: 'block',
              marginBottom: '8px',
              fontWeight: '600',
              color: '#495057',
              fontSize: '14px'
            }}>
              Select Section for this question:
            </label>
                          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                {this.state.sections.map((section, index) => (
                  <button
                    key={section.id}
                    onClick={() => this.handleSectionChange(index)}
                    style={{
                      padding: '6px 12px',
                      borderRadius: '15px',
                      border: 'none',
                      background: index === this.state.currentSection ? '#007bff' : '#e9ecef',
                      color: index === this.state.currentSection ? 'white' : '#495057',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '500'
                    }}
                  >
                    {section.name} ({section.questions.length}/{this.state.maxQuestionsPerSection})
                  </button>
                ))}
              </div>
          </div>
          
          {/* Progress Indicator */}
          <div style={{ 
            background: currentSection?.questions.length >= this.state.maxQuestionsPerSection 
              ? '#f8d7da' : currentSection?.questions.length >= this.state.maxQuestionsPerSection - 2 
              ? '#fff3cd' : '#e8f5e8', 
            padding: '10px', 
            borderRadius: '6px', 
            marginBottom: '15px',
            textAlign: 'center',
            border: currentSection?.questions.length >= this.state.maxQuestionsPerSection 
              ? '1px solid #f5c6cb' : currentSection?.questions.length >= this.state.maxQuestionsPerSection - 2 
              ? '1px solid #ffeaa7' : '1px solid #c3e6cb',
            display: this.state.useAIGeneration ? 'none' : 'block'
          }}>
            <span style={{ 
              color: currentSection?.questions.length >= this.state.maxQuestionsPerSection 
                ? '#721c24' : currentSection?.questions.length >= this.state.maxQuestionsPerSection - 2 
                ? '#856404' : '#2d5a2d', 
              fontWeight: '500', 
              fontSize: '14px' 
            }}>
              <strong>Section:</strong> {currentSection?.name} • 
              <strong>Questions:</strong> {currentSection?.questions.length || 0} of {this.state.maxQuestionsPerSection} • 
              <strong>LC Reward:</strong> {estimatedReward.toFixed(2)} LC
            </span>
            {currentSection?.questions.length >= this.state.maxQuestionsPerSection && (
              <div style={{ 
                marginTop: '5px', 
                color: '#721c24', 
                fontSize: '12px', 
                fontWeight: '600' 
              }}>
                ⚠️ This section is full! Switch to another section or create a new one to add more questions.
              </div>
            )}
            {currentSection?.questions.length >= this.state.maxQuestionsPerSection - 2 && 
             currentSection?.questions.length < this.state.maxQuestionsPerSection && (
              <div style={{ 
                marginTop: '5px', 
                color: '#856404', 
                fontSize: '12px', 
                fontWeight: '500' 
              }}>
                ⚠️ Section almost full! {this.state.maxQuestionsPerSection - (currentSection?.questions.length || 0)} questions remaining.
              </div>
            )}
          </div>
          
          {/* Questions List and Navigation */}
          {currentSection?.questions.length > 0 && (
            <div style={{
              background: '#f8f9fc',
              padding: '15px',
              borderRadius: '8px',
              marginBottom: '15px',
              border: '1px solid #e9ecef'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                <h6 style={{ margin: '0', color: '#495057', fontWeight: '600' }}>
                  📋 Questions in {currentSection?.name} ({currentSection?.questions.length})
                </h6>
                <button
                  onClick={this.toggleQuestionsList}
                  style={{
                    background: this.state.showQuestionsList ? '#dc3545' : '#007bff',
                    color: 'white',
                    border: 'none',
                    padding: '6px 12px',
                    borderRadius: '15px',
                    fontSize: '12px',
                    cursor: 'pointer',
                    fontWeight: '500'
                  }}
                >
                  {this.state.showQuestionsList ? '👁️ Hide Questions' : '👁️ Show Questions'}
                </button>
              </div>
              
              {this.state.showQuestionsList && (
                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                  {currentSection.questions.map((question, index) => (
                    <div key={index} style={{
                      background: this.state.editingQuestionIndex === index ? '#fff3cd' : 'white',
                      border: this.state.editingQuestionIndex === index ? '2px solid #ffc107' : '1px solid #dee2e6',
                      borderRadius: '8px',
                      padding: '12px',
                      marginBottom: '8px'
                    }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <div style={{ flex: 1, marginRight: '12px' }}>
                          <div style={{ fontWeight: '600', color: '#495057', marginBottom: '8px', fontSize: '14px' }}>
                            Q{index + 1}: {question.question}
                          </div>
                          <div style={{ fontSize: '13px', color: '#6c757d', marginBottom: '4px' }}>
                            <strong>Answers:</strong> A) {question.a1} | B) {question.a2} | C) {question.a3} | D) {question.a4}
                          </div>
                          <div style={{ fontSize: '13px', color: '#28a745', fontWeight: '600' }}>
                            <strong>Correct:</strong> {question.a5}
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '4px' }}>
                          <button
                            onClick={() => this.editQuestion(index)}
                            disabled={this.state.editingQuestionIndex === index}
                            style={{
                              background: this.state.editingQuestionIndex === index ? '#6c757d' : '#ffc107',
                              color: 'white',
                              border: 'none',
                              padding: '4px 8px',
                              borderRadius: '4px',
                              fontSize: '11px',
                              cursor: this.state.editingQuestionIndex === index ? 'not-allowed' : 'pointer',
                              fontWeight: '500'
                            }}
                            title={this.state.editingQuestionIndex === index ? 'Currently editing' : 'Edit this question'}
                          >
                            {this.state.editingQuestionIndex === index ? '✏️ Editing' : '✏️ Edit'}
                          </button>
                          <button
                            onClick={() => this.deleteQuestion(index)}
                            style={{
                              background: '#dc3545',
                              color: 'white',
                              border: 'none',
                              padding: '4px 8px',
                              borderRadius: '4px',
                              fontSize: '11px',
                              cursor: 'pointer',
                              fontWeight: '500'
                            }}
                            title="Delete this question"
                          >
                            🗑️
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              
              {!this.state.showQuestionsList && (
                <div style={{ fontSize: '13px', color: '#6c757d', fontStyle: 'italic' }}>
                  Click "Show Questions" to view, edit, or delete existing questions.
                </div>
              )}
              
              {this.state.showQuestionsList && (
                <div style={{ marginTop: '12px', textAlign: 'center' }}>
                  <button
                    onClick={() => {
                      this.clearQuestionForm();
                      this.setState({ showQuestionsList: false });
                    }}
                    style={{
                      background: '#28a745',
                      color: 'white',
                      border: 'none',
                      padding: '8px 16px',
                      borderRadius: '20px',
                      fontSize: '13px',
                      cursor: 'pointer',
                      fontWeight: '500'
                    }}
                  >
                    ➕ Add New Question
                  </button>
                </div>
              )}
            </div>
          )}
          
          {/* Editing Status */}
          {this.state.editingQuestionIndex >= 0 && (
            <div style={{
              background: '#fff3cd',
              padding: '12px',
              borderRadius: '6px',
              marginBottom: '15px',
              border: '1px solid #ffeaa7',
              textAlign: 'center'
            }}>
              <span style={{ color: '#856404', fontWeight: '600', fontSize: '14px' }}>
                ✏️ Editing Question {this.state.editingQuestionIndex + 1} • 
                <button
                  onClick={this.cancelEdit}
                  style={{
                    background: 'transparent',
                    color: '#856404',
                    border: 'none',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    marginLeft: '8px',
                    fontSize: '14px'
                  }}
                >
                  Cancel Edit
                </button>
              </span>
            </div>
          )}
          
          {/* <p><font color="#ffffff">..............................................................................</font></p> */}
      <Row>
          <Col sm={12}>
            <TextField
                //autoFocus={this.state.focus}
                id="sQuestion"
                label={this.state.editingQuestionIndex >= 0 
                  ? `Editing Question ${this.state.editingQuestionIndex + 1} for ${currentSection?.name}`
                  : `Enter Question ${(currentSection?.questions.length || 0) + 1} for ${currentSection?.name}`}
                multiline
                fullWidth
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                  style: { fontSize: isMobile ? '14px' : '16px' }
                }}
                inputProps={{ 
                  maxLength: 200,
                  style: { 
                    fontSize: isMobile ? '16px' : '14px', // Prevents zoom on iOS
                    padding: isMobile ? '12px' : '8px'
                  }
                }}
                style={{
                  marginBottom: isMobile ? '15px' : '10px',
                  display: this.state.useAIGeneration ? 'none' : 'block'
                }}
                aria-describedby="surveyTitle"
                onChange={event => {
                  const { value } = event.target;
                  this.setState({sQuestion: swapStuff(value)})
                }}
                //value={swapStuff(this.state.sQuestion)}
                value={ this.state.sQuestion ? swapStuff(this.state.sQuestion) : testHistory.q ? testHistory.q: ""}
              />
          </Col>
        </Row>  
         <Row>
         </Row>
         <Row>
          <Col sm={10}>
            <TextField
                // autoFocus
                //autoComplete
                id="sAnswer1"
                name="sAnswer1"
                //inputRef={(input) => this.sAnswer1 = input }
                ref="sAnswer1"
                label="Enter Answer 1"
                multiline
                fullWidth
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                  style: { fontSize: isMobile ? '14px' : '16px' }
                }}
                inputProps={{ 
                  maxLength: 200,
                  style: { 
                    fontSize: isMobile ? '16px' : '14px',
                    padding: isMobile ? '12px' : '8px'
                  }
                }}
                style={{
                  marginBottom: isMobile ? '15px' : '10px',
                  display: this.state.useAIGeneration ? 'none' : 'block'
                }}
                aria-describedby="answer"
                onChange={event => {
                  const { value } = event.target;
                  this.setState({sAnswer1: swapStuff(value)}) 
                }}
                //value={ this.state.submitLev===3 ? testHistory.a1 : swapStuff(this.state.sAnswer1)}
                //value={swapStuff(this.state.sAnswer1)}
                 value={ this.state.sAnswer1 ? swapStuff(this.state.sAnswer1) : testHistory.a1 ? testHistory.a1: ""}
              />
          </Col>
        </Row> 
        <Row>
          <Col sm={10}>
            <TextField
                // autoFocus
                id="sAnswer2"
                label="Enter Answer 2"
                multiline
                fullWidth
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                  style: { fontSize: isMobile ? '14px' : '16px' }
                }}
                inputProps={{ 
                  maxLength: 200,
                  style: { 
                    fontSize: isMobile ? '16px' : '14px',
                    padding: isMobile ? '12px' : '8px'
                  }
                }}
                style={{
                  marginBottom: isMobile ? '15px' : '10px',
                  display: this.state.useAIGeneration ? 'none' : 'block'
                }}
                aria-describedby="answer"
                onChange={event => {
                  const { value } = event.target;
                  this.setState({sAnswer2: swapStuff(value)})
                }}
                //value={swapStuff(this.state.sAnswer2)}
                value={ this.state.sAnswer2 ? swapStuff(this.state.sAnswer2) : testHistory.a2 ? testHistory.a2: ""}
                />
          </Col>
        </Row> 
        <Row>
          <Col sm={10}>
            <TextField
                // autoFocus
                id="sAnswer3"
                label="Enter Answer 3"
                multiline
                fullWidth
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                  style: { fontSize: isMobile ? '14px' : '16px' }
                }}
                inputProps={{ 
                  maxLength: 200,
                  style: { 
                    fontSize: isMobile ? '16px' : '14px',
                    padding: isMobile ? '12px' : '8px'
                  }
                }}
                style={{
                  marginBottom: isMobile ? '15px' : '10px',
                  display: this.state.useAIGeneration ? 'none' : 'block'
                }}
                aria-describedby="answer"
                onChange={event => {
                  const { value } = event.target;
                  this.setState({sAnswer3: swapStuff(value)})
                }}
                //value={swapStuff(this.state.sAnswer3)}
                value={ this.state.sAnswer3 ? swapStuff(this.state.sAnswer3) : testHistory.a3 ? testHistory.a3: ""}
              />
          </Col>
        </Row> 
        <Row>
          <Col sm={10}>
            <TextField
                // autoFocus
                id="sAnswer4"
                label="Enter Answer 4"
                multiline
                fullWidth
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                  style: { fontSize: isMobile ? '14px' : '16px' }
                }}
                inputProps={{ 
                  maxLength: 200,
                  style: { 
                    fontSize: isMobile ? '16px' : '14px',
                    padding: isMobile ? '12px' : '8px'
                  }
                }}
                style={{
                  marginBottom: isMobile ? '15px' : '10px',
                  display: this.state.useAIGeneration ? 'none' : 'block'
                }}
                aria-describedby="answer"
                onChange={event => {
                  const { value } = event.target;
                  this.setState({sAnswer4: swapStuff(value)})
                }}
                //value={swapStuff(this.state.sAnswer4)}
                value={ this.state.sAnswer4 ? swapStuff(this.state.sAnswer4) : testHistory.a4 ? testHistory.a4: ""}
              />
          </Col>
        </Row> 
  
    { this.state.typeofsurvey==="T"?
        <Row>
          <Col sm={10}>
          <Tooltip title={longText}>
            <TextField
                // autoFocus
                id="sAnswer5"
                label="Enter Correct Answer"
                multiline
                fullWidth
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ maxLength: 200 }}
                style={{
                  display: this.state.useAIGeneration ? 'none' : 'block'
                }}
                aria-describedby="answer"
                onChange={event => {
                  const { value } = event.target;
                  this.setState({sAnswer5: swapStuff(value)})
                }}
                //value={swapStuff(this.state.sAnswer5)}
                value={ this.state.sAnswer5 ? swapStuff(this.state.sAnswer5) : testHistory.a5 ? testHistory.a5: ""}
              />
              </Tooltip>
          </Col>
        </Row> 
       :
       <Row>
       <Col sm={10}>
       <input type="hidden"
             id="sAnswer5"
             aria-describedby="answer"
             value="no answer"
           />
       </Col>
     </Row> 
       }
        </React.Fragment> 
         :null
          // OR 
          // PUT IN SOME NICE MESSAGE
          }
          { this.state.Qnumber > 0 && this.state.Qnumber < 1000 ?
          <Row>
           <Col sm={8}></Col>
          <Col sm={8}>
          <FormControl>
           
            <DialogActions>
              <Button
                onClick={this.addQuestionToSection}
                disabled={
                  (this.state.editingQuestionIndex < 0 && this.state.sections[this.state.currentSection]?.questions?.length >= this.state.maxQuestionsPerSection) ||
                  (this.state.hasAttachments && (!this.state.transcript || this.state.transcript.trim() === '')) ||
                  (this.state.hasAttachments && !this.state.transcriptValidated)
                }
                style={{
                  ...sendBtn,
                  background: this.state.editingQuestionIndex >= 0 
                    ? '#ffc107' 
                    : (this.state.hasAttachments && (!this.state.transcript || this.state.transcript.trim() === ''))
                      ? '#dc3545'
                      : ((this.state.sections[this.state.currentSection]?.questions?.length >= this.state.maxQuestionsPerSection) || (this.state.hasAttachments && !this.state.transcriptValidated))
                        ? '#6c757d' 
                        : '#28a745',
                  marginRight: '10px',
                  cursor: (
                    (this.state.editingQuestionIndex < 0 && this.state.sections[this.state.currentSection]?.questions?.length >= this.state.maxQuestionsPerSection) ||
                    (this.state.hasAttachments && (!this.state.transcript || this.state.transcript.trim() === '')) ||
                    (this.state.hasAttachments && !this.state.transcriptValidated)
                  ) ? 'not-allowed' : 'pointer'
                }}
                title={this.state.editingQuestionIndex >= 0 
                  ? 'Update the question being edited'
                  : (this.state.hasAttachments && (!this.state.transcript || this.state.transcript.trim() === ''))
                    ? 'Transcript is required for leads with attachments'
                    : (this.state.sections[this.state.currentSection]?.questions?.length >= this.state.maxQuestionsPerSection 
                      ? `Section has reached maximum of ${this.state.maxQuestionsPerSection} questions. Switch to another section or create a new one.`
                      : 'Add question to current section')}
              >
                <SendIcon/>
                {this.state.editingQuestionIndex >= 0 
                  ? 'UPDATE QUESTION' 
                  : (this.state.hasAttachments && (!this.state.transcript || this.state.transcript.trim() === ''))
                    ? '📝 TRANSCRIPT REQUIRED'
                    : ((this.state.sections[this.state.currentSection]?.questions?.length >= this.state.maxQuestionsPerSection) || (this.state.hasAttachments && !this.state.transcriptValidated))
                      ? 'SECTION FULL' 
                      : 'ADD QUESTION'}
              </Button>
               
               <Button
                  onClick={() => {
                    if (this.state.hasAttachments && !this.state.transcriptValidated) {
                      alert('Please validate your transcript before publishing the manual test.');
                      return;
                    }
                    this.handlePublishTest();
                  }}
                  //autoFocus={true}
                  type="submit"
                  style={sendBtn2}
                >
                  <SendIcon/>
                  PUBLISH TEST
                </Button>
              </DialogActions>
            </FormControl>
          </Col>
        </Row>
        :null}
        {this.state.Qnumber > 0 && this.state.Qnumber < 1000 ?
        null
        :
        <React.Fragment>
          <div style={{
            position: 'sticky',
            bottom: '0',
            background: '#fff',
            padding: '20px 0',
            marginTop: '30px',
            borderTop: '1px solid #e9ecef',
            textAlign: 'center',
            zIndex: 1000,
            display: this.state.useAIGeneration ? 'none' : 'block'
          }}>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', alignItems: 'center' }}>
            <button 
              onClick={() => { 
                this.resetTest(); 
              }}
              style={{
                background: '#6c757d',
                color: '#fff',
                border: 'none',
                padding: '12px 30px',
                borderRadius: '25px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                transition: 'all 0.2s ease'
              }}
              onMouseOver={(e) => e.target.style.background = '#5a6268'}
              onMouseOut={(e) => e.target.style.background = '#6c757d'}
            > 
                Reset
              </button>
              
              <button 
                onClick={() => { 
                  this.allowExit();
                  if (handleClosex && typeof handleClosex === 'function') {
                    handleClosex(
                      this.props.thoughtID, 
                      this.props.real_companyID, 
                      this.props.companyID, 
                      this.props.showLeadb
                    ); 
                  }
                }}
                style={{
                  background: '#dc3545',
                  color: '#fff',
                  border: 'none',
                  padding: '12px 30px',
                  borderRadius: '25px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                  transition: 'all 0.2s ease'
                }}
                onMouseOver={(e) => e.target.style.background = '#c82333'}
                onMouseOut={(e) => e.target.style.background = '#dc3545'}
              > 
                Close
            </button>
            </div>
          </div>
         </React.Fragment>
        }
        
        {/* AI Test Validation Dialog */}
        <TestValidator
          open={this.state.showTestValidator}
          test={this.state.testValidationData}
          lead={this.state.leadContext}
          onClose={this.handleTestValidatorClose}
          onSubmit={this.handleTestValidatorSubmit}
        />

        {/* AI Test Preview */}
        {this.state.showAIPreview && this.state.aiGeneratedTest && (
          <div style={{
            maxWidth: isMobile ? '99%' : '800px',
            margin: '0 auto 20px auto',
            background: '#fff',
            borderRadius: '12px',
            padding: isMobile ? '10px' : '24px',
            boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
            border: '2px solid #28a745'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: '20px',
              borderBottom: '2px solid #e9ecef',
              paddingBottom: '15px'
            }}>
              <h4 style={{
                color: '#28a745',
                margin: '0',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                🤖 AI Generated Test Preview
              </h4>
              <div style={{
                background: '#e8f5e8',
                padding: '6px 12px',
                borderRadius: '20px',
                fontSize: '12px',
                color: '#2d5a2d',
                fontWeight: '600'
              }}>
                {this.state.aiGeneratedTest.sections.length} sections • {this.state.aiGeneratedTest.metadata?.totalQuestions || 'Multiple'} questions
              </div>
            </div>

            {/* Test Overview */}
            <div style={{
              background: '#f8f9fc',
              padding: '16px',
              borderRadius: '8px',
              marginBottom: '20px'
            }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px' }}>
                <div>
                  <strong style={{ color: '#495057' }}>Category:</strong>
                  <div style={{ color: '#6c757d' }}>{this.state.aiGeneratedTest.metadata?.category || 'Leadership'}</div>
                </div>
                <div>
                  <strong style={{ color: '#495057' }}>Difficulty:</strong>
                  <div style={{ color: '#6c757d', textTransform: 'capitalize' }}>{this.state.aiGeneratedTest.metadata?.difficulty || 'Medium'}</div>
                </div>
                <div>
                  <strong style={{ color: '#495057' }}>Total Questions:</strong>
                  <div style={{ color: '#6c757d' }}>{this.state.aiGeneratedTest.metadata?.totalQuestions || this.state.aiGeneratedTest.sections.reduce((sum, section) => sum + section.questions.length, 0)}</div>
                </div>
              </div>
            </div>

            {/* Sections and Questions Preview */}
            <div style={{ maxHeight: '500px', overflowY: 'auto', marginBottom: '20px' }}>
              {this.state.aiGeneratedTest.sections.map((section, sectionIndex) => (
                <div key={sectionIndex} style={{
                  marginBottom: '20px',
                  border: '1px solid #e9ecef',
                  borderRadius: '8px',
                  overflow: 'hidden'
                }}>
                  <div style={{
                    background: '#f8f9fc',
                    padding: '12px 16px',
                    borderBottom: '1px solid #e9ecef',
                    fontWeight: '600',
                    color: '#495057'
                  }}>
                    📁 {section.name} ({section.questions.length} questions)
                  </div>
                  
                  <div style={{ padding: '16px' }}>
                    {section.questions.map((question, qIndex) => (
                      <div key={qIndex} style={{
                        marginBottom: qIndex < section.questions.length - 1 ? '20px' : '0',
                        paddingBottom: qIndex < section.questions.length - 1 ? '20px' : '0',
                        borderBottom: qIndex < section.questions.length - 1 ? '1px solid #f1f3f4' : 'none'
                      }}>
                  <div 
                    style={{
                      fontWeight: '600',
                      marginBottom: '10px',
                      color: '#495057',
                      lineHeight: '1.4',
                      // === ANTI-COPY PROTECTION ===
                      userSelect: 'none',
                      WebkitUserSelect: 'none',
                      MozUserSelect: 'none',
                      msUserSelect: 'none',
                      WebkitTouchCallout: 'none'
                    }}
                    onCopy={this.preventCopy}
                    onCut={this.preventCopy}
                    onPaste={this.preventCopy}
                    onContextMenu={this.preventCopy}
                    onSelectStart={this.preventCopy}
                  >
                    {sectionIndex + 1}.{qIndex + 1}. {question.question}
                  </div>
                        
                        <div style={{ marginLeft: '20px' }}>
                          {question.options.map((option, optIndex) => (
                            <div key={optIndex} style={{
                              padding: '6px 0',
                              display: 'flex',
                              alignItems: 'flex-start',
                              gap: '8px'
                            }}>
                              <span style={{
                                //background: option === question.correctAnswer ? '#28a745' : '#6c757d',
                                background: '#6c757d',
                                color: 'white',
                                borderRadius: '50%',
                                width: '20px',
                                height: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '12px',
                                fontWeight: '600',
                                minWidth: '20px'
                              }}>
                                {String.fromCharCode(65 + optIndex)}
                              </span>
                              <span style={{
                                //color: option === question.correctAnswer ? '#28a745' : '#495057',
                                color: '#495057',
                                //fontWeight: option === question.correctAnswer ? '600' : '400',
                                fontWeight: '400',
                                lineHeight: '1.3'
                              }}>
                                {option}
                                {/* {option === question.correctAnswer && (
                                  <span style={{ color: '#28a745', marginLeft: '8px' }}>✓</span>
                                )} */}
                              </span>
                            </div>
                          ))}
                        </div>

                        <div style={{ marginTop: '10px', display: 'flex', gap: '8px' }}>
                          <button
                            onClick={() => this.regeneratePreviewQuestion(sectionIndex, qIndex)}
                            disabled={this.state.regeneratingQuestion === `${sectionIndex}-${qIndex}`}
                            style={{
                              padding: '8px 12px',
                              background: this.state.regeneratingQuestion === `${sectionIndex}-${qIndex}` ? '#6c757d' : '#007bff',
                              color: 'white',
                              border: 'none',
                              borderRadius: '6px',
                              fontSize: '12px',
                              fontWeight: '600',
                              cursor: this.state.regeneratingQuestion === `${sectionIndex}-${qIndex}` ? 'not-allowed' : 'pointer',
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '6px'
                            }}
                          >
                            {this.state.regeneratingQuestion === `${sectionIndex}-${qIndex}` ? 'Regenerating…' : '🔄 Regenerate'}
                          </button>
                        </div>
                        {this.state.regeneratingQuestion === `${sectionIndex}-${qIndex}` && (
                          <div style={{
                            marginTop: '6px',
                            fontSize: '12px',
                            color: '#555',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                          }}>
                            <span className="ai-loading"></span>
                            Generating a new question. This can take up to a minute…
                          </div>
                        )}
                        
                        {question.explanation && (
                          <div style={{
                            marginTop: '10px',
                            padding: '8px 12px',
                            background: '#e8f4fd',
                            borderRadius: '6px',
                            fontSize: '13px',
                            color: '#0c5460',
                            fontStyle: 'italic'
                          }}>
                            💡 {question.explanation}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

                           {/* Action Buttons */}
               <div style={{
                 display: 'flex',
                 gap: '12px',
                 justifyContent: 'center',
                 flexWrap: 'wrap',
                 borderTop: '2px solid #e9ecef',
                 paddingTop: '20px'
               }}>
                 <button
                   onClick={this.acceptAITest}
                   style={{
                     padding: '12px 24px',
                     background: '#28a745',
                     color: 'white',
                     border: 'none',
                     borderRadius: '8px',
                     fontSize: '14px',
                     fontWeight: '600',
                     cursor: 'pointer',
                     display: 'flex',
                     alignItems: 'center',
                     gap: '8px'
                   }}
                 >
                   🚀 Publish Now
                 </button>
                 
                 <button
                   onClick={this.acceptAITestForEditing}
                   style={{
                     padding: '12px 24px',
                     background: '#17a2b8',
                     color: 'white',
                     border: 'none',
                     borderRadius: '8px',
                     fontSize: '14px',
                     fontWeight: '600',
                     cursor: 'pointer',
                     display: 'flex',
                     alignItems: 'center',
                     gap: '8px'
                   }}
                 >
                   ✏️ Accept & Edit
                 </button>
              
              <button
                onClick={this.regenerateAITest}
                disabled={this.state.generatingTest}
                style={{
                  padding: '12px 24px',
                  background: this.state.generatingTest ? '#6c757d' : '#007bff',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: this.state.generatingTest ? 'not-allowed' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                {this.state.generatingTest ? (
                  <>
                    <span className="ai-loading"></span>
                    Regenerating...
                  </>
                ) : (
                  <>
                    🔄 Regenerate Test
                  </>
                )}
              </button>
              
              <button
                onClick={this.rejectAITest}
                style={{
                  padding: '12px 24px',
                  background: '#ffc107',
                  color: '#212529',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                ⚙️ Modify Config
              </button>
              
              <button
                onClick={this.cancelAIPreview}
                style={{
                  padding: '12px 24px',
                  background: '#dc3545',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                ❌ Cancel & Go Manual
              </button>
            </div>

                           {/* Tips */}
               <div style={{
                 marginTop: '15px',
                 padding: '12px',
                 background: '#fff3cd',
                 border: '1px solid #ffeaa7',
                 borderRadius: '6px',
                 fontSize: '13px',
                 color: '#856404'
               }}>
                 💡 <strong>Choose your option:</strong> "Publish Now" immediately publishes the test and awards points. "Accept & Edit" lets you review and modify questions before publishing. The correct answer is highlighted in green above.
               </div>
          </div>
        )}
              </div>
      </div>
    );
    }
   }
   
  const mapStateToProps = state => {
    const thoughtsRoot = state.thoughts || {};
    const candidateArrays = [
      thoughtsRoot.ilead,
      thoughtsRoot.thoughts,
      thoughtsRoot.organisational,
      thoughtsRoot.gcthoughts,
      thoughtsRoot.groupposts,
      thoughtsRoot.dailythoughts,
      thoughtsRoot.mythoughts
    ];
    const combinedThoughts = [];
    candidateArrays.forEach(arr => {
      if (Array.isArray(arr)) {
        combinedThoughts.push(...arr);
      }
    });
    return {
      userdata: state.userDialog.userDetails[0],
      update_Survey: state.updateSurvey.update_Survey,
      testHistory: state.testHistory,
      thoughts: thoughtsRoot,
      thoughtsData: combinedThoughts,
      competenciesList: state.competenciesList || {}
    };
  };
  
  const mapDispatchToProps = dispatch => {
  return {
    showToast: params => dispatch(showToast(params)),
    createSurvey: params => dispatch(createSurvey(params)),
    updateSurvey: params => dispatch(updateSurvey(params)),
    addMorePoints: params => dispatch(addMorePoints(params)),
    testHistoryActions: params => dispatch(testHistoryActions(params)),
    saveTestAttempt: params => dispatch(saveTestAttempt(params)),
    getTestAttempt: params => dispatch(getTestAttempt(params)),
    updateTestAttempt: params => dispatch(updateTestAttempt(params)),
  };
};
  
  export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateaSurvey));